ScoreTrekBattle.Tournament.Live = (function() {
    var _this, STATUS, CONFIG, SCROLL_TOP, MENU, MAP, OBSERVER, OBSERVER_VISIBLE_ELEMENTS, TIMER;

    CONFIG = {
        POLL_DELAY: 10000,
        POLL_RUNNING_DELAY: 10000,
        LUCKY_LOSER: {
            REEL_MIN_ITEMS: 18,
            REEL_ROUNDS: 4,
            REEL_TOGGLE_DURATION: 200,
            REEL_SPIN_DURATION: 2600,
            REEL_REVEAL_DELAY: 900
        }
    };

    TIMER = {};

    function resetStatus() {
        STATUS = {
            active: false,
            scrolling: true,
            gamesDialog: null,
            gotoGameId: null,
            tab: '',
            $view: null,
            redirect: null,
            isStarting: false,
            isRunning: false,
            tournament: null,
            nextTournament: null,
            prevTournaments: [],
            rounds: null,
            ranking: null,
            pollTimestamp: 0
        };

        ScoreTrekBattle.Tournament.setCurrent(null);
    }

    function resetMap() {
        MAP = {
            ROUNDS: {},
            GROUPS: {},
            GAMES: {},
            TEAMS: {},
            MENU: {}
        };
    }

    function resetMenu() {
        MENU = {
            tournament: {
                label: __i18n('tournament/menu/tournament/label'),
                items: []
            },
            groups: [],
            doubleKnockout: {
                label: __i18n('tournament/menu/doubleKnockout'),
                items: []
            },
            singleKnockout: {
                label: __i18n('tournament/menu/singleKnockout'),
                items: []
            },
            manager: {
                label: __i18n('tournament/menu/manager'),
                onlyBattleManager: true,
                items: []
            }
        };
    }

    function resetObserver() {
        try {
            OBSERVER.disconnect();
        } catch(ignore) {}

        OBSERVER_VISIBLE_ELEMENTS = {};
        OBSERVER = null;
    }

    function resetAll() {
        resetStatus();
        resetMenu();
        resetMap();
        resetObserver();
        stopPolling();
    }
    resetAll();

    function loadScrollTop() {
        SCROLL_TOP = chmStorage.getSession('Live.ScrollTop');
        if (!SCROLL_TOP) {
            SCROLL_TOP = {};
        }
    }
    loadScrollTop();

    function storeScrollTop(scrollTop) {
        if (!STATUS.tournament || STATUS.scrolling) {
            return;
        }
        SCROLL_TOP[STATUS.tournament.id] = scrollTop;
        chmStorage.setSession('Live.ScrollTop', SCROLL_TOP);
    }

    function restoreScrollTop() {
        let status;

        if (!STATUS.tournament) {
            return;
        }
        if (!SCROLL_TOP.hasOwnProperty(STATUS.tournament.id)) {
            SCROLL_TOP[STATUS.tournament.id] = 0;
        }
        status = STATUS;
        status.scrolling = true;
        AnimationHandler.scrollTo(SCROLL_TOP[STATUS.tournament.id], true, STATUS.$view).then(() => {
            setTimeout(() => {
                status.scrolling = false;
            }, 1000);
        });
    }


    function onViewRender(tournamentId, gameId) {
        return new Promise(function(resolve) {
            var hasError;

            STATUS.active = true;

            ScoreTrekBattle.$body.addClass('hasSideMenu');

            if (gameId) {
                STATUS.gotoGameId = gameId;
            }

            hasError = false;

            ScoreTrekBattle.View.loading('Tournament.Live.onViewRender', true);
            loadData(tournamentId).then(() => {
                if (!STATUS.tournament || STATUS.redirect) {
                    return;
                }

                if (!STATUS.tournament.isFinalized && (['running', 'done'].indexOf(STATUS.tournament.status) >= 0)) {
                    STATUS.isRunning = true;
                    return;
                }


                if (STATUS.tournament.status === 'starting') {
                    STATUS.isStarting = true;
                    return;
                }
            }).catch(error => {
                hasError = true;
                resetAll();
                chmDialog.error(error).then(() => {
                    ScoreTrekBattle.View.goto('/');
                });
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Live.onViewRender', false);

                if (STATUS.redirect) {
                    ScoreTrekBattle.View.goto(STATUS.redirect, false, true);
                    resolve(null);
                    return;
                }

                if (!STATUS.tournament) {
                    resolve(null);
                    return;
                }
                renderContainer().then(view => {
                    STATUS.active = true;
                    STATUS.$view = view.$view;
                    STATUS.$view.find('[data-id="tournamentInfo"]').css('display', hasError ? 'none' : '');

                    renderPrevNextTournaments().then(() => {
                        if (!STATUS.tournament) {
                            resolve(null);
                            return;
                        }

                        if (!STATUS.tournament.series) {
                            STATUS.$view.find('[data-ref-id="tournamentSeries"]').remove();
                        }

                        if (!STATUS.tournament.nextTournamentId) {
                            STATUS.$view.find('[data-ref-id="prevTournament"]').remove();
                        }

                        if (!STATUS.tournament.isNextTournament) {
                            STATUS.$view.find('[data-ref-id="nextTournament"]').remove();
                        }

                        if (!STATUS.tournament.pointsMapId) {
                            STATUS.$view.find('[data-ref-id="tournamentPointsMap"]').remove();
                        }

                        resolve(STATUS.$view);
                    });
                });
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            if (!STATUS.tournament || STATUS.redirect) {
                resolve();
                return;
            }
            ScoreTrekBattle.View.updateMenu(ScoreTrekBattle.Tournament.getMenuLink(STATUS.tournament.statusInfo));
            ScoreTrekBattle.View.loading('Tournament.Live.onViewLoad', true);
            renderData().then(() => {
                renderMenu().then(() => {
                    renderRanking(STATUS.ranking);
                    toggleTournamentArea('details', false);
                    toggleTournamentArea('ranking', (STATUS.tournament.status === 'done'));
                    updateGroupMenuItems();
                    updateMatchStatus();
                    startPolling();
                    pollGames();
                    resolve();
                    setTimeout(() => {
                        startObserver();
                        if (STATUS.gotoGameId) {
                            gotoMatch(STATUS.gotoGameId);
                            STATUS.scrolling = false;
                        } else {
                            restoreScrollTop();
                        }
                        ScoreTrekBattle.View.loading('Tournament.Live.onViewLoad', false);
                    }, 1000);
                });
            });
        });
    }

    function onViewUpdate(tournamentId, gameId) {
        return new Promise(function(resolve) {
            storeScrollTop(AnimationHandler.getScrollTop());
            resetAll();
            onViewRender(tournamentId, gameId).then($view => {
                if (!$view) {
                    resolve();
                    return;
                }

                ScoreTrekBattle.View.replace($view);
                onViewLoad().then(resolve);
            });
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            storeScrollTop(AnimationHandler.getScrollTop());
            resetAll();
            resolve();
        });
    }

    function startPolling() {
        if (!STATUS.tournament || STATUS.tournament.isFinalized) {
            return;
        }

        stopPolling();

        TIMER.polling = setInterval(() => {
            if (!STATUS.active) {
                stopPolling();
                return;
            }
            pollGames();
        }, CONFIG.POLL_DELAY);

        TIMER.runningGames = setInterval(() => {
            if (!STATUS.active) {
                stopPolling();
                return;
            }
            pollRunningGames();
        }, CONFIG.POLL_RUNNING_DELAY);
    }

    function stopPolling() {
        clearInterval(TIMER.polling);
        TIMER.polling = null;
        clearInterval(TIMER.runningGames);
        TIMER.runningGames = null;
    }

    function pollGames() {
        Api.request('/battle/poll/games', {
            tournamentId: STATUS.tournament.id,
            timestamp: STATUS.pollTimestamp
        }).then(result => {
            handlePollResult(result);
        }).catch(ignore => {});
    }

    function pollRunningGames() {
        let gameIds;
        
        gameIds = getRunningGamesIds();

        if (gameIds.length === 0) {
            return;
        }

        Api.request('/battle/games/info', {
            tournamentId: STATUS.tournament.id,
            gameIds: gameIds
        }).then(result => {
            handlePollRunningGames(result);
        }).catch(ignore => {});
    }

    function handlePollResult(result) {
        if (!result) {
            return;
        }

        if (result.timestamp) {
            STATUS.pollTimestamp = result.timestamp;
        }

        if (result.games) {
            update(result.games);
        }

        if (result.teams) {
            updateTeams(result.teams);
        }

        if (result.updateRanking) {
            updateRankings();
        }

        if (result.rounds) {
            updateRounds(result.rounds);
        }

        if (result.tables) {
            updateTables(result.tables);
        }
    }

    function handlePollRunningGames(result) {
        if (!result) {
            return;
        }

        if (result.games) {
            updateRunningGames(result.games);
        }
    }

    function startObserver() {
        resetObserver();

        OBSERVER = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    OBSERVER_VISIBLE_ELEMENTS[entry.target.dataset.anchor] = entry.target;
                } else {
                    delete OBSERVER_VISIBLE_ELEMENTS[entry.target.dataset.anchor];
                }
            });
            activateElements(Object.values(OBSERVER_VISIBLE_ELEMENTS));
        }, {
            root: document,
            rootMargin: ScoreTrekBattle.View.getRootMargin(),
            threshold: 0
        });

        document.querySelectorAll('.observeIntersection').forEach(element => {
            OBSERVER.observe(element);
        });
    }

    function activateElements(elements) {
        deactivateElements();
        elements.forEach(element => {
            activateElement(element.dataset.anchor);
        });
    }

    function activateElement(anchor, onlyOne) {
        var anchor, menuItem;

        menuItem = document.querySelector(`[data-ref-anchor="${anchor}"]`);

        if (onlyOne) {
            deactivateElements();
        }

        if (menuItem) {
            menuItem.classList.add('isActive');
        }
    }

    function deactivateElements() {
        if (!STATUS.$view) {
            return;
        }

        STATUS.$view.find('[data-id="menu"] [data-ref-anchor]').removeClass('isActive');
    }

    function loadData(tournamentId) {
        return new Promise(function(resolve, reject) {
            Promise.all([
                loadTournamentData(tournamentId),
                Api.request('/battle/tournament/rounds', {id: tournamentId}),
                Api.request('/battle/tournament/teams', {id: tournamentId}),
                loadRanking(tournamentId),
                loadRelatedTournaments(tournamentId)
            ]).then(results => {
                STATUS.tournament = results[0].tournament;
                STATUS.pollTimestamp = results[0].timestamp;
                STATUS.rounds = results[1].rounds;
                STATUS.teams = results[2].teams;
                STATUS.ranking = (results[3] && results[3].ranking) ? results[3].ranking : null;
                STATUS.nextTournament = results[4].nextTournament || null;
                STATUS.prevTournaments = results[4].prevTournaments || [];

                if (['scheduled', 'annulled'].indexOf(STATUS.tournament.status) >= 0) {
                    STATUS.redirect = `/tournament/details/${STATUS.tournament.id}`;
                    resolve();
                    return;
                }

                ScoreTrekBattle.Tournament.setCurrent(STATUS.tournament);

                resetMap();

                STATUS.teams.forEach(team => {
                    MAP.TEAMS[team.id] = team;
                });

                STATUS.rounds.forEach(round => {
                    var groups;
                    MAP.ROUNDS[round.id] = round;
                    groups = getRoundGroups(round);
                    groups.forEach(group => {
                        if (group.id) {
                            MAP.GROUPS[group.id] = group;
                        }
                        group.games.forEach(game => {
                            MAP.GAMES[game.id] = game;
                        });
                    });
                });

                resolve();
            }).catch(reject);
        });
    }

    function loadTournamentData(tournamentId, isFirstLoad) {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/tournament/minimal', {id: tournamentId}).then(result => {
                resolve(result);
            }).catch(reject);
        });
    }

    function loadRelatedTournaments(tournamentId) {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/tournament/related', {id: tournamentId}).then(result => {
                resolve(result);
            }).catch(reject);
        });
    }

    function renderMenu() {
        return new Promise(function(resolve) {
            var groupPromises;

            groupPromises = [];

            groupPromises.push(renderMenuFilters());

            MAP.MENU = {};

            Object.values(MENU).forEach(menuGroup => {
                if (Array.isArray(menuGroup)) {
                    menuGroup.forEach(menuSubGroup => {
                        groupPromises.push(renderMenuGroup(menuSubGroup));
                    });
                    return;
                }
                groupPromises.push(renderMenuGroup(menuGroup));
            });

            groupPromises.push(renderMenuStatus());


            Promise.all(groupPromises).then($menuGroups => {
                STATUS.$view.find('[data-id="menu"]').empty().append($menuGroups);
                renderStatusData();
                STATUS.$view.find('[data-id="menuToggle"]').on('click', function(event) {
                    ScoreTrekBattle.$body.toggleClass('sideMenu-open');
                });
            }).catch(error => {
                chmDialog.error(error);
            }).finally(resolve);
        });
    }

    function renderMenuFilters() {
        return new Promise(function(resolve) {
            resolve('');
        });
    }

    function renderMenuStatus() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/live/menu/status', {tournament: STATUS.tournament}).then(view => {
                resolve(view.$view);
            });
        });
    }

    function renderPrevNextTournaments() {
        return new Promise(resolve => {
            if (!STATUS.tournament || !STATUS.$view) {
                resolve();
                return;
            }
            ScoreTrekBattle.Tournament.renderInfos(STATUS.tournament, STATUS.$view);
            ScoreTrekBattle.Tournament.renderModeInfo(STATUS.tournament, STATUS.$view);

            Promise.all([
                ScoreTrekBattle.Tournament.renderPrevTournaments(STATUS.prevTournaments, STATUS.$view.find('[data-id="prevTournaments"]')),
                ScoreTrekBattle.Tournament.renderNextTournament(STATUS.nextTournament, STATUS.$view.find('[data-id="nextTournament"]'), STATUS.tournament.qualificantsCount)
            ]).then(() => {
                resolve();
            });
        });

    }

    function updateStatus() {
        loadTournamentData(STATUS.tournament.id).then(result => {
            STATUS.tournament = (result && result.tournament) ? result.tournament : null;
            ScoreTrekBattle.Tournament.setCurrent(STATUS.tournament);
            
            if (STATUS.isStarting && (STATUS.tournament.status === 'running')) {
                ScoreTrekBattle.View.reload();
                return;
            }

            if (STATUS.isRunning && (['scheduled', 'annulled'].indexOf(STATUS.tournament.status) >= 0)) {
                ScoreTrekBattle.View.reload();
                return;
            }

            renderStatusData();
            startPolling();

            updateTables(result.tables);

        }).catch(error => {
            console.warn(error);
        })
    }

    function updateGroupsProgress() {
        STATUS.$view.find('[data-group-id]').each(function() {
            updateGroupProgress($(this));
        });
    }

    function updateGroupProgress($group) {
        let $matches, $groupMenuItem, total, done, progress;

        $matches = $group.find('[data-id="groupMatches"]').children();

        total = $matches.length;
        done = $matches.filter('[data-game-status="done"]').length;
        progress = Math.max(0, Math.min(100, (Math.round((done / total) * 100) || 0)));

        $groupMenuItem = STATUS.$view.find(`[data-menu-group-id="${getMenuGroupId($group.attr('data-group-id'))}"]`);
        $groupMenuItem.toggleClass('isDone', (done === total));
        $groupMenuItem.get(0).style.setProperty('--progress', `${progress}%`);
        $groupMenuItem.find(`[data-id="groupProgress"]`).text(`${done} / ${total}`);
    }

    function updateMatchStatus() {
        let occupiedTeams;

        if (!STATUS.$view) {
            return;
        }

        occupiedTeams = {};

        ScoreTrekBattle.$body.find('[data-game-id]').removeClass('hasOccupiedTeams');
        
        ScoreTrekBattle.$body.find('[data-game-id][data-game-status="running"]').each(function() {
            let match;

            match = this;
            
            ['gameTeam1', 'gameTeam2'].forEach(teamKey => {
                let teamId;

                teamId = match.dataset[teamKey];
                if (teamId && teamId !== '__BYE__') {
                    occupiedTeams[teamId] = true;
                }
            });
        });

        ScoreTrekBattle.$body.find('[data-game-id][data-game-status="ready"]').each(function() {
            if (occupiedTeams[this.dataset.gameTeam1] || occupiedTeams[this.dataset.gameTeam2]) {
                this.classList.add('hasOccupiedTeams');
            }
        });
    }

    function renderStatusData() {
        var $status, progress;

        $status = STATUS.$view.find('[data-id="tournamentStatus"]');

        progress = Math.max(0, Math.min(100, (Math.round((STATUS.tournament.gamesDone / STATUS.tournament.gamesTotal) * 100) || 0)));

        $status.toggleClass('isDone', (progress === 100));
        $status.get(0).style.setProperty('--progress', `${progress}%`);
        $status.find(`[data-id="progress"]`).text(`${progress}%`);

        toggleControls();
        applyStatus();

        ['gamesTotal', 'gamesDone', 'gamesPending', 'gamesRunning'].forEach(tournamentKey => {
            $status.find(`[data-id="${tournamentKey}"]`).text(STATUS.tournament[tournamentKey]);
        });
    }

    function renderMenuGroup(menuGroup) {
        return new Promise(function(resolve, reject) {
            var itemPromises;

            if (menuGroup.items.length === 0) {
                resolve('');
                return;
            }

            itemPromises = [];

            ScoreTrekBattle.Template.render('tournament/live/menu/group', {
                menuGroup: menuGroup
            }).then(view => {
                menuGroup.items.forEach(menuItem => {
                    itemPromises.push(renderMenuItem(menuItem));
                });
                Promise.all(itemPromises).then($menuItems => {
                    var $items, $toggle;
                    
                    $items = view.$view.find('[data-id="items"]');
                    $toggle = view.$view.find('[data-id="toggle"]');

                    view.$view.toggleClass('hasProgress', !!menuGroup.hasProgress);
                    view.$view.find('[data-id="groupProgressWrapper"]').on('click', function(event) {
                        event.stopPropagation();
                        event.preventDefault();
                    });

                    if (menuGroup.onlyBattleManager) {
                        view.$view.addClass('show-battle-manager').attr('data-show-for-club', STATUS.tournament.clubId);
                    }

                    $items.empty().append($menuItems);
                    $toggle.on('click', function() {
                        var isOpen;
                        isOpen = (view.$view.attr('data-open') === 'no');
                        view.$view.attr('data-open', isOpen ? 'yes' : 'no');
                        $items.stop()[isOpen ? 'slideDown' : 'slideUp']();
                        storeOpenState(menuGroup.id, isOpen);
                    });

                    if (!getOpenState(menuGroup.id)) {
                        view.$view.attr('data-open', 'no');
                        $items.hide();
                    }

                    resolve(view.$view);
                }).catch(reject);
            }).catch(reject);
        });
    }

    function renderMenuItem(menuItem) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/live/menu/item', {
                menuItem: menuItem
            }).then(view => {
                MAP.MENU[menuItem.anchor] = view.$view;

                if (menuItem.isAdmin) {
                    view.$view.addClass('show-battle-manager').attr('data-show-for-club', STATUS.tournament.clubId);
                }

                view.$view.on('click', function() {
                    var menuItemElement, $element;

                    menuItemElement = this;

                    $element = $(`[data-anchor="${menuItemElement.dataset.refAnchor}"]`);

                    forceToggleOpen($element);
                    AnimationHandler.scrollIntoView($element, $element.height() > (0.8 * window.innerHeight)).then(() => {
                        AnimationHandler.pulse($element);
                        activateElement(menuItemElement.dataset.refAnchor);
                    });
                });
                resolve(view.$view);
            });
        });
    }

    function renderContainer() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/live/live', {
                tournament: STATUS.tournament,
                googleMapsUrl: ScoreTrekBattle.Tournament.getMapsUrl(STATUS.tournament)
            }).then(view => {
                view.$view.find('[data-ref-id="overview"]').remove();

                resolve(view);
            });
        });
    }

    function renderData() {
        return new Promise(function(resolve) {
            resetMenu();

            MENU.tournament.id = `tournament_menu_${STATUS.tournament.id}_tournament`;
            MENU.doubleKnockout.id = `tournament_menu_${STATUS.tournament.id}_doubleKnockout`;
            MENU.singleKnockout.id = `tournament_menu_${STATUS.tournament.id}_singleKnockout`;

            toggleControls();
            applyStatus();
            toggleHasControls();
            toggleTreeView();

            STATUS.$view.find(`[data-id="tournamentTitle"]`).text(STATUS.tournament.title);

            MENU.tournament.items.push({
                icon: '<i class="fa-solid fa-location-dot"></i>',
                label: __i18n('tournament/menu/tournament/details'),
                anchor: `${STATUS.tournament.id}_details`
            });

            if (STATUS.isStarting) {
                resolve();
                return;
            }

            MENU.tournament.items.push({
                icon: '<i class="fa-solid fa-trophy"></i>',
                label: __i18n('tournament/menu/tournament/positions'),
                anchor: `${STATUS.tournament.id}_rankings`
            });

            renderRounds(STATUS.rounds).then($rounds => {
                STATUS.$view.find('[data-id="rounds"]').empty().append($rounds);
                MENU.manager.items.push({
                    icon: '<i class="fa-solid fa-clipboard-check"></i>',
                    label: __i18n('round/finalization'),
                    anchor: `${STATUS.tournament.id}_finalization`,
                    isAdmin: true
                });
                resolve();
            });
        });
    }

    function renderRounds(rounds) {
        return new Promise(function(resolve) {
            let roundPromises, partition;
            roundPromises = [];
            partition = [];
            rounds.forEach(round => {
                if (round.partition) {
                    if ((partition.length > 0) && (round.index !== partition[partition.length - 1].index)) {
                        roundPromises.push(renderPartitionRounds(partition));
                        partition = [];
                    }
                    partition.push(round);
                    return;
                }
                roundPromises.push(renderRound(round));
            });
            if (partition.length > 0) {
                roundPromises.push(renderPartitionRounds(partition));
            }
            Promise.all(roundPromises).then($rounds => {
                resolve($rounds);
            });
        });
    }

    function renderPartitionRounds(partition) {
        return new Promise(function(resolve) {
            let partitionPromises;

            partitionPromises = [];
            partition.forEach(round => {
                partitionPromises.push(renderRound(round));
            });

            Promise.all(partitionPromises).then($rounds => {
                resolve($('<div>').addClass('live-rounds-partitions').attr('data-rounds', $rounds.length).append($rounds));
            });
        });
    }

    function renderRound(round) {
        return new Promise(function(resolve) {
            var roundName, roundNameShort, anchor;

            roundName = getRoundName(round);
            roundNameShort = getRoundName(round, true);

            anchor = `${STATUS.tournament.id}_${round.id}`;

            if (['group', 'versus'].indexOf(round.type) < 0) {
                isSingleKnockout = ((round.type === 'knockout') && (round.subType === 'single'));
                MENU[isSingleKnockout ? 'singleKnockout' : 'doubleKnockout'].items.push({
                    icon: '<i class="fa-solid fa-diagram-project"></i>',
                    label: roundNameShort,
                    anchor: anchor
                });
            }

            ScoreTrekBattle.Template.render('tournament/live/round', {
                roundTitle: roundName
            }).then(view => {
                renderRoundData(round, view.$view);

                toggleElementHasControls(view.$view);

                if (round.type === 'group') {
                    view.$view.find('[data-id="roundHeader"]').attr('data-anchor', anchor);
                } else {
                    view.$view.attr('data-anchor', anchor);
                }

                renderGroups(getRoundGroups(round)).then($groups => {
                    view.$view.find('[data-id="roundGroups"]').empty().append($groups);
                    view.$view.find('[data-id="groupMatches"]').get().forEach(groupMatches => {
                        if (groupMatches.dataset.anchor === '') {
                            groupMatches.dataset.anchor = anchor;
                        }
                    });

                    updateRoundStatus(round, view.$view);

                    resolve(view.$view);
                });
            });
        });
    }

    function renderRoundData(round, $round) {
        let isOpen;

        if (!round) {
            return;
        }

        MAP.ROUNDS[round.id] = round;
        
        if (!$round) {
            $round = STATUS.$view.find(`[data-round-id="${round.id}"]`);
        }

        isOpen = getOpenState(round.id);

        $round.toggleClass('hasGroups', !!round.groups);
        $round.toggleClass('isRandomDraw', round.isRandomDraw);
        $round.attr({
            'data-round-id': round.id,
            'data-round-type': round.type,
            'data-round-sub-type': round.subType,
            'data-is-random-draw-pending': round.isRandomDrawPending ? 'yes' : 'no',
            'data-is-open': isOpen ? 'yes' : 'no',
            'data-is-editable': round.isEditable ? 'yes' : 'no',
            'data-is-edited': round.isEdited ? 'yes' : 'no',
            'data-toggle-id': `${round.id}`
        });

        if (!isOpen) {
            $round.find('[data-ref="toggle"]').first().hide();
        }
    }

    function toggleTournamentArea(area, defaultState) {
        let toggleId, isOpen;

        toggleId = `tournament_${STATUS.tournament.id}_${area}`;

        isOpen = getOpenState(toggleId, defaultState);

        forceToggleOpen(STATUS.$view.find(`[data-toggle-id="${toggleId}"]`), isOpen);
    }

    function forceToggleOpen($child, isOpen) {
        let $toggleParent;

        isOpen = (isOpen !== false);

        $toggleParent = $child.closest('[data-toggle-id]');

        if ($toggleParent.length === 0) {
            return;
        }

        $toggleParent.attr('data-is-open', isOpen ? 'yes' : 'no').find('[data-ref="toggle"]').first()[isOpen ? 'show' : 'hide']();

        forceToggleOpen($toggleParent.parent(), isOpen);
    }

    function storeOpenState(itemId, isOpen) {
        sessionStorage.setItem(`${itemId}_open`, isOpen ? 'yes' : 'no');
    }

    function getOpenState(itemId, defaultState) {
        let openState;

        openState = sessionStorage.getItem(`${itemId}_open`);

        if (openState === null) {
            return (defaultState !== false);
        }

        return (openState !== 'no');
    }

    function updateRoundStatus(round, $round) {
        if (!round) {
            return;
        }

        MAP.ROUNDS[round.id] = round;
        
        if (!$round) {
            $round = STATUS.$view.find(`[data-round-id="${round.id}"]`);
        }

        $round.find('[data-id="randomDrawControls"] .button').prop('disabled', !round.isRandomDraw || !isDrawAvailable(round));
    }

    function renderGroups(groups) {
        return new Promise(function(resolve) {
            var groupPromises;
            groupPromises = [];
            groups.forEach(group => {
                groupPromises.push(renderGroup(group));
            });
            Promise.all(groupPromises).then($groups => {
                resolve($groups);
            });
        });
    }

    function renderGroup(group) {
        return new Promise(function(resolve) {
            var groupName, anchor, groupMenuItems;

            groupName = getGroupName(group);

            if (group && group.id) {
                anchor = {
                    groups: `${STATUS.tournament.id}_${group.id}_groups`,
                    rankings: `${STATUS.tournament.id}_${group.id}_rankings`,
                };

                groupMenuItems = [];

                groupMenuItems.push({
                    icon: '<i class="fa-solid fa-people-arrows"></i>',
                    label: __i18n('tournament/title/matches'),
                    anchor: anchor.groups
                });

                groupMenuItems.push({
                    icon: '<i class="fa-solid fa-medal"></i>',
                    label: __i18n('tournament/title/rankings'),
                    anchor: anchor.rankings
                });

                MENU.groups.push({
                    label: groupName,
                    id: getMenuGroupId(group.id),
                    hasProgress: true,
                    items: groupMenuItems
                });
            }

            ScoreTrekBattle.Template.render('tournament/live/group', {
                clubId: STATUS.tournament.clubId,
                groupTitleMatches: `${groupName} <span class="color-white-60">&ndash; ${__i18n('tournament/title/matches')}</span>`,
                groupTitleRankings: `${groupName} <span class="color-white-60">&ndash; ${__i18n('tournament/title/rankings')}</span>`
            }).then(view => {
                Promise.all([
                    renderGames(group.games),
                    ScoreTrekBattle.Tournament.Ranking.render(STATUS.$view, STATUS.tournament, MAP.TEAMS, group.ranking, group.qualificantsCount)
                ]).then(results => {
                    let $games, $rankings, toggles;

                    $games = results[0];
                    $rankings = results[1];

                    toggleElementHasControls(view.$view);

                    toggles = {
                        ranking: {
                            toggleId: `${group.id}_ranking`,
                            isOpen: true
                        },
                        matches: {
                            toggleId: `${group.id}_matches`,
                            isOpen: true
                        }
                    };

                    Object.values(toggles).forEach(toggle => {
                        toggle.isOpen = getOpenState(toggle.toggleId);
                    });

                    view.$view.attr({
                        'data-group-id': group.id,
                        'data-group-number': group.number,
                        'data-group-name': group.number ? __i18n('game/group', {group: group.number}) : ''
                    });

                    view.$view.toggleClass('hasPendingConflict', group.hasConflict || false);
                    view.$view.toggleClass('hasSolvedConflict', group.isConflictSolved || false);

                    view.$view.find('[data-id="groupMatches"]').empty().append($games);
                    view.$view.find('[data-id="groupMatchesWrapper"]').attr({
                        'data-anchor': anchor ? anchor.groups : '',
                        'data-is-open': toggles.matches.isOpen ? 'yes' : 'no',
                        'data-toggle-id': toggles.matches.toggleId,
                    });
                    view.$view.find('[data-id="groupRankings"]').attr('data-qualificants', group.qualificantsCount).empty().append($rankings);
                    view.$view.find('[data-id="groupRankingsWrapper"]').attr({
                        'data-anchor': anchor ? anchor.rankings : '',
                        'data-is-open': toggles.ranking.isOpen ? 'yes' : 'no',
                        'data-toggle-id': toggles.ranking.toggleId
                    });

                    Object.values(toggles).forEach(toggle => {
                        if (!toggle.isOpen) {
                            view.$view.find(`[data-toggle-id="${toggle.toggleId}"] [data-ref="toggle"]`).first().hide();
                        }
                    });

                    if ($rankings) {
                        view.$view.addClass('hasRankings');
                    }

                    resolve(view.$view);
                });
            });
        });
    }

    function renderGames(games) {
        return new Promise(function(resolve) {
            var gamePromises;
            gamePromises = [];
            games.forEach(game => {
                gamePromises.push(renderGame(game));
            });
            Promise.all(gamePromises).then($games => {
                resolve($games);
            });
        });
    }

    function renderGame(game) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('tournament/live/match', {game: game}).then(view => {
                MAP.GAMES[game.id] = game;
                renderGameData(game, view.$view).then(() => {
                    resolve(view.$view);
                });
            });
        });
    }

    function renderGameData(game, $game, highlightUpdates) {
        return new Promise(function(resolve) {
            var teamPromises, gameTimestamp, isRunning, hasChanges, hasHistory, isInTreeView, gameData, gameHtml;

            gameTimestamp = parseInt($game.attr('data-timestamp'), 10);
            if (isNaN(gameTimestamp)) {
                gameTimestamp = 0;
            }
            $game.attr('data-timestamp', game.modifiedTimestamp);

            isInTreeView = $game.hasClass('isTreeView');

            teamPromises = [];
            ['team1', 'team2'].forEach(teamKey => {
                var hasTeam, options, $team;

                hasTeam = (game[teamKey] !== '');

                $team = $game.find(`[data-id="${teamKey}"] [data-team-id]`);

                options = $.extend({
                    allowHighlight: hasTeam ? 'yes' : 'no',
                    isClickable: true
                }, ($team.length === 0) ? {
                    toggle: isInTreeView ? 'disabled' : undefined,
                } : {
                    toggle: isInTreeView ? 'disabled' : (($team[0].dataset.toggle !== 'disabled') ? $team[0].dataset.toggle : undefined),
                    highlight: $team.attr('data-highlight'),
                    hover: $team.attr('data-hover')
                });

                teamPromises.push(renderTeam(teamKey, game, hasTeam ? game[teamKey] : game[`${teamKey}From`], hasTeam, options).then($team => {
                    $game.find(`[data-id="${teamKey}"]`).empty().append($team);
                }));
            });

            ['gameTarget', 'result1', 'result2', 'duration'].forEach(resultKey => {
                $game.find(`[data-id="${resultKey}"]`).html(autoFormatGameAttribute(resultKey, game[resultKey]));
            });

            applyGameStats($game, game);

            if (game.isTie) {
                $game.find(`[data-id="result1"],[data-id="result2"]`).html('<i class="fa-solid fa-handshake-simple"></i>');
            }

            isRunning = (game.status === 'running');

            hasHistory = hasGameHistory(game);
            
            gameData = {
                'data-game-id': game.id,
                'data-game-table-id': game.tableId,
                'data-is-random-draw-pending': game.isRandomDrawPending ? 'yes' : 'no',
                'data-match-has-history': hasHistory ? 'yes' : 'no',
                'data-match-has-bye': (hasBye(game) || (game.team2Designated === '__BYE__')) ? 'yes' : 'no',
                'data-game-number': game.number,
                'data-game-target': game.gameTarget,
                'data-game-status': getGameStatus(game),
                'data-time-status': getTimeStatus(game),
                'data-game-team1': game.team1,
                'data-game-team2': game.team2,
                'data-game-result1': game.result1,
                'data-game-result2': game.result2
            };

            hasChanges = false;

            Object.keys(gameData).forEach(attrKey => {
                hasChanges =  hasChanges || (String($game.attr(attrKey)) !== String(gameData[attrKey]));
            });

            gameHtml = $game.html();

            $game.attr(gameData);

            $game.find('[data-id="tableName"]').html(getTableName(game));
            $game.find('[data-id="scoreboardName"]').html(getScoreboardName(game));

            $game.find('[data-id="matchName"]').text(getGameName(game.number));
            $game.find(`[data-id="matchInfo"]`).html(`<b>${getGameName(game.number)}</b> - ${game.type}: ${__i18n(`gameType/${game.gameType}`)} <i class="fa-solid fa-square-up-right"></i> ${game.gameTarget} (${game.duration})`);

            $game.find('[data-id="matchDuration"],[data-id="matchTable"]')[isRunning ? (highlightUpdates ? 'slideDown' : 'show') : (highlightUpdates ? 'slideUp' : 'hide')]();

            $game.find('[data-id="tieRank"]').css('display', game.isTieAllowed ? '' : 'none');

            hasChanges = hasChanges || (gameHtml !== $game.html());

            Promise.all(teamPromises).then(() => {
                if (highlightUpdates && hasChanges) {
                    AnimationHandler.highlight($game);
                }
                resolve();
            });
        });
    }

    function autoFormatGameAttribute(key, value) {
        if (key === 'gameTarget') {
            return value || '<i class="fa-solid fa-infinity"></i>'
        }

        return value;
    }

    function applyStatus() {
        STATUS.$view.attr('data-tournament-status', STATUS.tournament.statusInfo);

    }

    function toggleControls() {
        STATUS.$view.find('[data-id="buttonFinalize"]').prop('disabled', (STATUS.tournament.isFinalized || ((STATUS.tournament.status !== 'done') && !ScoreTrekBattle.Session.isAdminMode())));
        STATUS.$view.find('[data-id="buttonUnseal"]').prop('disabled', !STATUS.tournament.isFinalized);
    }

    function hasTreeView() {
        return (STATUS.tournament.preset && STATUS.tournament.preset.hasTreeView);
    }

    function toggleTreeView() {
        if (!STATUS.$view) {
            return;
        }

        STATUS.$view.find('[data-ref="treeView"]').css('display', hasTreeView() ? '' : 'none');
    }

    function toggleHasControls() {
        toggleElementHasControls(STATUS.$view);
    }

    function toggleElementHasControls($element) {
        if (!$element) {
            return;
        }
        $element.toggleClass('hasControls', isEditable());
    }

    function isEditable() {
        if (!STATUS.tournament) {
            return false;
        }

        return (ScoreTrekBattle.Session.isAdminMode() || (ScoreTrekBattle.Session.isBattleManager() && ScoreTrekBattle.Session.isClubUser(STATUS.tournament.clubId)));
    }

    function renderTeam(teamKey, game, teamId, hasTeam, options) {
        return new Promise(function(resolve) {
            var team, teamIdParts, teamSize, isRandomDrawPending;

            team = MAP.TEAMS[teamId];
            teamSize = STATUS.tournament.preset.teamSize;
            isRandomDrawPending = (teamKey === 'team2') && (game && game.isRandomDrawPending);

            if (isRandomDrawPending || !team || !hasTeam) {
                teamIdParts = String(teamId).split(':');
                ScoreTrekBattle.Tournament.Match.renderPending(
                    getTeamFrom(teamKey, game, teamIdParts[0] || '', teamIdParts[1] || ''),
                    {
                        teamSize: teamSize,
                        icon: isRandomDrawPending ? '<i class="fa-solid fa-dice"></i>' : ((!teamId || (teamId === '__BYE__')) ? '<i class="fa-solid fa-user-slash"></i>' : null)
                    }
                ).then(resolve).catch(error => {
                    console.error(error);
                    resolve(renderTeamError());
                });
                return;
            }

            options = $.extend({
                teamSize: teamSize,
                toggle: (teamSize > 1) ? 'closed' : 'disabled',
                isClickable: false
            }, options);

            ScoreTrekBattle.Tournament.Match.renderTeam(
                STATUS.$view,
                team,
                options
            ).then($team => {
                resolve($team);
            }).catch(error => {
                console.error(error);
                resolve(renderTeamError());
            });
        });
    }

    function hasAlternatingBreak() {
        let preset;

        preset = (STATUS.tournament.preset && STATUS.tournament.preset.preset) ? STATUS.tournament.preset.preset : {};

        return (preset.alternatingBreak === 'yes');
    }

    function applyBreakMode($info, gameType, isAlternatingBreak) {
        $info.find('[data-id="breakMode"]').css('display', ScoreTrekBattle.Tournament.Preset.Edit.allowAlternatingBreak(gameType) ? '' : 'none');
        $info.find('[data-id="breakModeLabel"]').text(__i18n(`modeInfo/alternatingBreak/${isAlternatingBreak ? 'yes' : 'no'}`));
    }

    function hasGameHistory(game) {
        return !!(game && game.history && game.history.balls && game.history.points);
    }

    function applyGameStats($game, game) {
        let hasTakes, hasMaxBreak;

        hasTakes = false;
        hasMaxBreak = false;

        ['1', '2'].forEach(teamNumber => {
            let takes, maxBreak, result;

            takes = game ? (parseInt(game[`takes${teamNumber}`], 10) || 0) : 0;
            maxBreak = game ? (parseInt(game[`maxBreak${teamNumber}`], 10) || 0) : 0;
            result = game ? (parseInt(game[`result${teamNumber}`], 10) || 0) : 0;

            hasTakes = hasTakes || (takes > 0);
            hasMaxBreak = hasMaxBreak || (maxBreak > 0);

            $game.find(`[data-id="takes${teamNumber}"]`).text(takes);
            $game.find(`[data-id="maxBreak${teamNumber}"]`).text(maxBreak);
            $game.find(`[data-id="average${teamNumber}"]`).text((takes > 0) ? Numbers.floatToString(result / takes, 2) : '–');
        });

        $game.find('[data-ref="statsTakes"],[data-ref="statsAverage"]').css('display', hasTakes ? '' : 'none');
        $game.find('[data-ref="statsMaxBreak"]').css('display', hasMaxBreak ? '' : 'none');
    }

    function renderTeamError() {
        return `<span class="color-light-pink"><i class="fa-solid fa-triangle-exclamation"></i> ${__i18n('tournament/team/none')}</span>`;
    }

    function showMatchInfo(game) {
        ScoreTrekBattle.Template.render('tournament/match/info', {
            game: game,
            tournament: STATUS.tournament,
            gameStatus: getGameStatus(game),
            timeStatus: getTimeStatus(game),
            tableName: getTableName(game),
            scoreboardName: getScoreboardName(game)
        }).then(view => {
            renderGameData(game, view.$view).then(() => {
                var hasFrom, info;

                hasFrom = (game.team1From || game.team2From);

                ['winner', 'loser'].forEach(teamType => {
                    var teamTo;
                    teamTo = getTeamTo(game, teamType);
                    view.$view.find(`[data-id="${teamType}To"]`).html(teamTo.html).css('display', teamTo.valid ? '' : 'none');
                });

                if (game.isTie) {
                    view.$view.find(`[data-id="loserTo"]`).css('display', 'none');
                }

                ['1', '2'].forEach(teamNumber => {
                    var gameTeamFrom, teamFrom;
                    gameTeamFrom = game[`team${teamNumber}From`].split(':');
                    teamFrom = getTeamFrom(`team${teamNumber}`, game, gameTeamFrom[0] || '', gameTeamFrom[1] || '');
                    if ((teamNumber === '2') && game.isRandomDraw) {
                        hasFrom = true;
                        teamFrom = `<i class="fa-solid fa-dice"></i> ${teamFrom}`;
                    }
                    view.$view.find(`[data-id="team${teamNumber}From"]`).html(
                        __i18n('player/teamFrom', {number: teamNumber, from: teamFrom})
                    ).css('display', hasFrom ? '' : 'none');
                });

                info = __i18n(`match/info/${game.type}`);
                view.$view.find('[data-id="matchInfo"]').html(info).css('display', info ? '' : 'none');

                view.$view.find('[data-id="tieInfo"]').css('display', (game.isTieAllowed && !game.isTie) ? '' : 'none');

                view.$view.find('[data-id="tieNotice"]').css('display', (game.isTieAllowed && game.isTie) ? '' : 'none');

                view.$view.find('[data-id="timeLimitWrapper"]').css('display', game.timeLimitMinutes ? '' : 'none');

                applyBreakMode(view.$view, game.gameType, hasAlternatingBreak());

                chmDialog({
                    title: __i18n('dialog/match/info/title', {gameName: getGameName(game.number)}),
                    content: view.$view
                });
            });
        });
    }

    function getAllGames(sorted) {
        let games;
        games = Object.values(MAP.GAMES);
        if (!sorted) {
            return games;
        }

        games.sort((gameA, gameB) => {
            return (gameA.number < gameB.number) ? -1 : 1;
        });

        return games;
    }

    function getRunningGamesIds() {
        return Object.values(MAP.GAMES).filter(game => (game.status === 'running')).map(game => game.id);
    }

    function getGameStatus(game) {
        return game ? (game.isRandomDrawPending ? 'pending' : game.status) : '';
    }

    function getTimeStatus(game) {
        return (game && game.timeLimitSeconds) ? ((game.durationSeconds > game.timeLimitSeconds) ? 'overdue' : 'ok') : 'ok';
    }

    function getTableName(game) {
        return (game.tableName === '') ? __i18n('table/none') : __escapeHTML(game.tableName);
    }

    function getScoreboardName(game) {
        return (game.scoreboardName === '') ? __i18n('table/scoreboard/none') : __escapeHTML(game.scoreboardName);
    }

    function getTeamFrom(teamKey, targetGame, referenceId, teamType) {
        let isDraw;

        isDraw = (teamKey === 'team2') && (targetGame && targetGame.isRandomDrawPending);

        if (isDraw) {
            return __i18n(`player/draw`);
        }

        return ScoreTrekBattle.Tournament.Match.renderTeamFrom(teamType, MAP.GAMES[referenceId], MAP.GROUPS[referenceId]);
    }


    function getTeamTo(game, teamType) {
        var teamTo, toParts, toGameId, toTeamKey, toGame, toGameName, isRandomDraw, toGame, toPosition, valid, round;

        valid = false;
        teamTo = '<span class="color-light-pink">???</span>';
        toPosition = game[`${game.isTie ? 'winner' : teamType}Position`];
        isRandomDraw = false;

        toParts = String(game[`${game.isTie ? 'tie' : teamType}To`]).split(':');

        toGameId = toParts.shift();
        toTeamKey = toParts.shift();

        toGame = MAP.GAMES[toGameId];

        if (toGame) {
            toGameName = getGameName(toGame.number);
            valid = true;
            round = MAP.ROUNDS[toGame.roundId];
        }


        if ((toTeamKey === 'team2') && (round && round.isRandomDraw)) {
            isRandomDraw = true;
        }

        if (toPosition !== 0) {
            teamTo = __i18n('player/position', {position: getPositionText(game, toPosition)});
            valid = true;
            if (game.type === 'smallFinal') {
                teamTo = toGameName.concat(` <span class="color-white-60">${__i18n('connector/or')}</span> `).concat(teamTo);
            }
        } else if (isRandomDraw) {
            teamTo = `<i class="fa-solid fa-dice"></i> ${__i18n('player/draw')}`;
            valid = true;
        } else if (toGameName) {
            teamTo = toGameName;
            valid = true;
        }

        return {
            valid: valid,
            html: __i18n(`player/${game.isTie ? 'tie' : teamType}To`, {to: teamTo})
        };
    }

    function getTeamDisplayName(team) {
        if (!team) {
            return 'n/a';
        }

        if (team.participants.length > 1) {
            return team.name;
        }

        return team.participants[0].fullName || 'n/a';
    }

    function getTeamName(teamId) {
        return getTeamDisplayName(MAP.TEAMS[teamId]);
    }

    function getTeamHandicap(teamId) {
        let team;
        
        team = MAP.TEAMS[teamId];

        return team ? (team.handicap || 0) : 0;
    }

    function getPositionText(game, position) {
        let round;

        round = MAP.ROUNDS[game.roundId];

        if (!round || !round.partition) {
            return `${position}`;
        }

        return `${round.partition} ${position}`;
    }

    function getGameName(gameNumber) {
        return __i18n('game/name', {number: gameNumber});
    }

    function getGroupName(group) {
        if (!group) {
            return '';
        }

        return group.number ? __i18n('game/group', {group: group.number}) : __i18n('group/versus');
    }

    function getMenuGroupId(groupId) {
        return `${STATUS.tournament.id}_${groupId}`;
    }

    function getRoundName(round, short) {
        var roundTitle, isSingleGameRound, isSingleKnockoutRound, isDoubleKnockoutRound, isKnockoutRound, isGroupRound;

        if (!round) {
            return '';
        }

        roundTitle = [];

        isSingleGameRound = (round.games && (round.games.length === 1) && (round.games[0].type !== 'knockout'));
        isGroupRound = (round.type === 'group');
        isSingleKnockoutRound = (round.type === 'knockout') && (round.subType === 'single');
        isDoubleKnockoutRound = (round.type === 'knockout') && ((round.subType === 'doubleWinner') || (round.subType === 'doubleLoser'));
        isKnockoutRound = (round.type === 'knockout');


        if (short) {
            if (isSingleGameRound) {
                roundTitle.push(round.number);
                roundTitle.push(__i18n(`match/roundType/${round.games[0].type}`));
            } else if (isDoubleKnockoutRound) {
                roundTitle.push(round.number);
                roundTitle.push(__i18n(`round/knockout/${round.subType}`));
            } else if (isSingleKnockoutRound) {
                if (round.games.length <= 8) {
                    roundTitle.push(round.number);
                    roundTitle.push(__i18n(`tournament/create/choice/rounds/type/last${round.games.length * 2}`));
                } else {
                    roundTitle.push(round.number);
                    roundTitle.push(__i18n(`round/knockout/single`));
                }
            } else {
                roundTitle.push(round.number);
                roundTitle.push(__i18n(`round/${round.type}`));
            }
        } else {
            if (!isGroupRound && round.number) {
                roundTitle.push(__i18n('game/round', {round: round.number}));
            }
            if (isSingleGameRound) {
                roundTitle.push(__i18n(`match/roundType/${round.games[0].type}`));
            } else if (isSingleKnockoutRound) {
                roundTitle.push(__i18n(`round/knockout/single`));
                if (round.games.length <= 8) {
                    roundTitle.push(__i18n(`tournament/create/choice/rounds/type/last${round.games.length * 2}`));
                }
            } else if (isKnockoutRound) {
                roundTitle.push(__i18n(`round/knockout/double`));
                roundTitle.push(__i18n(`round/knockout/${round.subType}`));
            } else {
                roundTitle.push(__i18n(`round/${round.type}`));
            }
        }

        return roundTitle.join(' · ');
    }

    function getRoundGroups(round) {
        return round.groups || [{
            games: round.games,
            ranking: null
        }];
    }

    // action: finalize | unseal
    function triggerTournamentAction(action, actionParams, confirmationVars) {
        if (!STATUS.tournament) {
            return;
        }

        chmDialog.confirm(
            __i18n(`dialog/confirm/${action}Tournament/text`,
            $.extend(
                {tournamentName: STATUS.tournament.title},
                confirmationVars
            ),
            true), {
            title: __i18n(`dialog/confirm/${action}Tournament/title`),
            buttonYes: __i18n(`button/${action}Tournament`),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            doTournamentAction(action, actionParams);
        }).catch(ignore => {});
    }

    // action: finalize | unseal
    function doTournamentAction(action, actionParams, rejectOnError) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Live.doTournamentAction', true);
            tournamentAction(action, actionParams).then(result => {
                updateMatchStatus();
                updateGroupsProgress();
                updateStatus();
                updateRankings();
                resolve(result);
            }).catch(error => {
                if (rejectOnError) {
                    reject(error);
                    return;
                }
                chmDialog.error(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Live.doTournamentAction', false);
            });
        });
    }

    // action: finalize | unseal
    function tournamentAction(action, actionParams) {
        return new Promise(function(resolve, reject) {
            if (!STATUS.tournament) {
                resolve();
                return;
            }

            actionParams = $.extend({
                tournamentId: STATUS.tournament.id
            }, actionParams);

            Api.request(`/battle/tournament/${action}`, actionParams).then(result => {
                if (result && result.done) {
                    if (result.tournament) {
                        ScoreTrekBattle.Event.trigger('tournament.updated', result.tournament);
                    }
                    resolve(result);
                } else {
                    reject(new Error('STATUS_TRANSITION_FAILED'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    function getLuckyLoserCandidates(luckyLoserStatus) {
        let luckyLoserIds;

        luckyLoserIds = luckyLoserStatus.luckyLosers.map(luckyLoser => {
            return luckyLoser.id;
        });

        return luckyLoserStatus.allCandidates.filter(candidate => {
            return (luckyLoserIds.indexOf(candidate.id) === -1);
        });
    }

    function updateLuckyLoserControls(luckyLoserStatus) {
        let hasCandidates;

        hasCandidates = (getLuckyLoserCandidates(luckyLoserStatus).length > 0);

        luckyLoserStatus.$view.find('[data-id="luckyLoserAdd"]').toggleClass('isDisabled', !hasCandidates || luckyLoserStatus.isDrawing);
    }

    function renderLuckyLoserReelItem(team) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.render('tournament/live/luckyLoserReelItem').then(view => {
                view.$view.find('[data-id="reelTeamName"]').text(getTeamDisplayName(team));
                resolve(view.$view);
            }).catch(reject);
        });
    }

    function buildLuckyLoserReelTeams(candidates, winner) {
        let reelTeams, reelItemsCount, index;

        reelItemsCount = Math.max(CONFIG.LUCKY_LOSER.REEL_MIN_ITEMS, candidates.length * CONFIG.LUCKY_LOSER.REEL_ROUNDS);

        reelTeams = [];
        index = Math.floor(Math.random() * candidates.length);

        while (reelTeams.length < reelItemsCount) {
            reelTeams.push(candidates[index % candidates.length]);
            index++;
        }

        if ((candidates.length > 1) && (reelTeams[reelTeams.length - 1].id === winner.id)) {
            reelTeams.pop();
        }

        reelTeams.push(winner);

        return reelTeams;
    }

    function scrollToLuckyLoserTarget(luckyLoserStatus, isQuick) {
        let dialog;

        dialog = luckyLoserStatus.$view.closest('.dialog').get(0);

        if (!dialog) {
            return Promise.resolve();
        }

        return AnimationHandler.scrollTo(dialog.scrollHeight - dialog.clientHeight, isQuick, luckyLoserStatus.$view);
    }

    function spinLuckyLoserReel(luckyLoserStatus, candidates, winner) {
        return new Promise(function(resolve, reject) {
            let reelItemPromises;

            reelItemPromises = buildLuckyLoserReelTeams(candidates, winner).map(team => {
                return renderLuckyLoserReelItem(team);
            });

            Promise.all(reelItemPromises).then($reelItems => {
                let $reel, $strip, strip;

                $reel = luckyLoserStatus.$view.find('[data-id="luckyLoserReel"]');
                $strip = luckyLoserStatus.$view.find('[data-id="luckyLoserReelStrip"]');
                strip = $strip.get(0);

                $reel.removeClass('isSpinning hasWinner');
                $strip.empty().append($reelItems);

                strip.style.transition = 'none';
                strip.style.transform = 'translateY(0)';

                $reel.stop(true, true).slideDown(CONFIG.LUCKY_LOSER.REEL_TOGGLE_DURATION, function() {
                    let itemHeight;

                    itemHeight = $strip.children().first().outerHeight();

                    void strip.offsetHeight;

                    $reel.addClass('isSpinning');

                    strip.style.transition = `transform ${CONFIG.LUCKY_LOSER.REEL_SPIN_DURATION}ms cubic-bezier(0.1, 0.85, 0.2, 1)`;
                    strip.style.transform = `translateY(${-1 * ($reelItems.length - 1) * itemHeight}px)`;

                    setTimeout(() => {
                        $reel.removeClass('isSpinning').addClass('hasWinner');
                        AnimationHandler.pulse($reel);
                        setTimeout(resolve, CONFIG.LUCKY_LOSER.REEL_REVEAL_DELAY);
                    }, CONFIG.LUCKY_LOSER.REEL_SPIN_DURATION);
                });
            }).catch(reject);
        });
    }

    function hideLuckyLoserReel(luckyLoserStatus) {
        let $reel;

        $reel = luckyLoserStatus.$view.find('[data-id="luckyLoserReel"]');

        $reel.stop(true, true).slideUp(CONFIG.LUCKY_LOSER.REEL_TOGGLE_DURATION, function() {
            $reel.removeClass('hasWinner');
            $reel.find('[data-id="luckyLoserReelStrip"]').empty();
        });
    }

    function renderLuckyLoserItem(luckyLoserStatus, team) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Tournament.Match.renderTeam(
                null,
                team,
                {
                    teamSize: team.participants.length,
                    toggle: 'disabled',
                    isClickable: false
                }
            ).then($team => {
                ScoreTrekBattle.Template.render('tournament/live/luckyLoserItem', {
                    teamId: team.id
                }).then(view => {
                    view.$view.find('[data-id="luckyLoserItemTeam"]').empty().append($team);
                    view.$view.find('[data-id="luckyLoserItemRemove"]').on('click', function() {
                        confirmRemoveLuckyLoser(luckyLoserStatus, team);
                    });
                    resolve(view.$view);
                }).catch(reject);
            }).catch(reject);
        });
    }

    function confirmRemoveLuckyLoser(luckyLoserStatus, team) {
        chmDialog.confirm(__i18n('dialog/confirm/removeLuckyLoser/text', {teamName: getTeamDisplayName(team)}, true), {
            title: __i18n('dialog/confirm/removeLuckyLoser/title'),
            buttonYes: __i18n('button/remove'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            removeLuckyLoser(luckyLoserStatus, team);
        }).catch(ignore => {});
    }

    function removeLuckyLoser(luckyLoserStatus, team) {
        let $item;

        luckyLoserStatus.luckyLosers = luckyLoserStatus.luckyLosers.filter(luckyLoser => {
            return (luckyLoser.id !== team.id);
        });

        $item = luckyLoserStatus.$qualificants.find(`[data-id="luckyLoserItem"][data-team-id="${team.id}"]`);

        $item.slideUp(CONFIG.LUCKY_LOSER.REEL_TOGGLE_DURATION, function() {
            $item.remove();
        });

        updateLuckyLoserControls(luckyLoserStatus);
    }

    function drawLuckyLoser(luckyLoserStatus, isQuick) {
        let candidates, winner;

        if (luckyLoserStatus.isDrawing) {
            return;
        }

        candidates = getLuckyLoserCandidates(luckyLoserStatus);

        if (candidates.length === 0) {
            return;
        }

        winner = candidates[Math.floor(Math.random() * candidates.length)];

        luckyLoserStatus.isDrawing = true;
        luckyLoserStatus.$view.toggleClass('isDrawing', !isQuick);
        updateLuckyLoserControls(luckyLoserStatus);

        scrollToLuckyLoserTarget(luckyLoserStatus, isQuick).then(() => {
            if (isQuick) {
                return Promise.resolve();
            }

            return spinLuckyLoserReel(luckyLoserStatus, candidates, winner);
        }).then(() => {
            return renderLuckyLoserItem(luckyLoserStatus, winner);
        }).then($item => {
            luckyLoserStatus.luckyLosers.push(winner);

            if (isQuick) {
                luckyLoserStatus.$qualificants.append($item);
                AnimationHandler.scrollIntoView($item, false, true);
                return;
            }

            luckyLoserStatus.$qualificants.append($item.hide());
            $item.slideDown(CONFIG.LUCKY_LOSER.REEL_TOGGLE_DURATION, function() {
                AnimationHandler.scrollIntoView($item);
            });

            hideLuckyLoserReel(luckyLoserStatus);
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            luckyLoserStatus.isDrawing = false;
            luckyLoserStatus.$view.removeClass('isDrawing');
            updateLuckyLoserControls(luckyLoserStatus);
        });
    }

    function updateLuckyLoserActionsOffset(luckyLoserStatus, dialogButtons) {
        luckyLoserStatus.$view.get(0).style.setProperty('--luckyLoser-actions-offset', `${dialogButtons.offsetHeight}px`);
    }

    function watchLuckyLoserActionsOffset(luckyLoserStatus) {
        let dialogButtons;

        dialogButtons = luckyLoserStatus.$view.closest('.dialog').find('.dialog-buttons').get(0);

        if (!dialogButtons) {
            return;
        }

        updateLuckyLoserActionsOffset(luckyLoserStatus, dialogButtons);

        if (!window.ResizeObserver) {
            return;
        }

        luckyLoserStatus.actionsObserver = new ResizeObserver(() => {
            updateLuckyLoserActionsOffset(luckyLoserStatus, dialogButtons);
        });

        luckyLoserStatus.actionsObserver.observe(dialogButtons);
    }

    function releaseLuckyLoser(luckyLoserStatus) {
        if (!luckyLoserStatus.actionsObserver) {
            return;
        }

        luckyLoserStatus.actionsObserver.disconnect();
        luckyLoserStatus.actionsObserver = null;
    }

    function applyLuckyLoserFinalization(luckyLoserStatus, onFinalized) {
        doTournamentAction('finalize', {
            luckyLoserTeamIds: luckyLoserStatus.luckyLosers.map(luckyLoser => {
                return luckyLoser.id;
            })
        }, true).then(() => {
            onFinalized();
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function initLuckyLoser($view, luckyLoserCandidates) {
        let luckyLoserStatus;

        luckyLoserStatus = {
            $view: $view,
            $qualificants: $view.find('[data-id="qualificants"]'),
            allCandidates: luckyLoserCandidates || [],
            luckyLosers: [],
            isDrawing: false,
            actionsObserver: null
        };

        luckyLoserStatus.$view.find('[data-id="luckyLoserAdd"]').on('click', function(event) {
            drawLuckyLoser(luckyLoserStatus, event.ctrlKey || event.metaKey);
        });

        updateLuckyLoserControls(luckyLoserStatus);

        return luckyLoserStatus;
    }

    function confirmFinalization(confirmation, confirmationVars) {
        return new Promise(function(resolve, reject) {
            let teamPromises;

            if (!confirmation) {
                reject(new Error('MISSING_CONFIRMATION_DATA'));
                return;
            }

            if (confirmation.type !== 'nextTournament') {
                reject(new Error('INVALID_CONFIRMATION_TYPE'));
                return;
            }

            if (!confirmation.nextTournament || !confirmation.qualificants) {
                reject(new Error('INVALID_CONFIRMATION_DATA'));
                return;
            }

            if (confirmation.qualificants.length === 0) {
                resolve(false);
                return;
            }

            teamPromises = confirmation.qualificants.map(team => {
                return new Promise(function(resolve) {
                    ScoreTrekBattle.Tournament.Match.renderTeam(
                        null,
                        team,
                        {
                            teamSize: team.participants.length,
                            toggle: 'disabled',
                            isClickable: false
                        }
                    ).then($team => {
                        resolve($team);
                    }).catch(error => {
                        console.error(error);
                        resolve(renderTeamError());
                    });
                });
            });

            Promise.all(teamPromises).then($teams => {
                ScoreTrekBattle.Template.render('tournament/live/confirmQualification', {
                    tournament: STATUS.tournament,
                    nextTournament: confirmation.nextTournament,
                    pointsMapNotice: __i18n('dialog/confirm/finalizeTournament/pointsMap', confirmationVars, true)
                }).then(view => {
                    let luckyLoserStatus, dialog, isFinalized;

                    view.$view.find('[data-id="qualificants"]').empty().append($teams);

                    luckyLoserStatus = initLuckyLoser(view.$view, confirmation.luckyLoserCandidates);

                    isFinalized = false;

                    dialog = chmDialog({
                        title: `<span class="text-yellow"><i class="fa-solid fa-clipboard-question"></i></span> ${__i18n('dialog/confirm/finalizeQualification/title')}`,
                        content: view.$view,
                        isPersistant: true,
                        buttons: [
                            {
                                label: __i18n('button/apply'),
                                primary: true,
                                action: () => {
                                    applyLuckyLoserFinalization(luckyLoserStatus, function() {
                                        isFinalized = true;
                                        dialog.close();
                                    });
                                    return false;
                                }
                            },
                            {
                                label: __i18n('button/cancel')
                            }
                        ],
                        onShow: function() {
                            watchLuckyLoserActionsOffset(luckyLoserStatus);
                        },
                        afterClose: function(fromBack) {
                            releaseLuckyLoser(luckyLoserStatus);

                            if (fromBack) {
                                return;
                            }

                            if (isFinalized) {
                                resolve(true);
                                return;
                            }

                            reject(null);
                        }
                    });
                }).catch(reject);
            });
        });
    }

    function finishGameWithBye(game) {
        if (!game) {
            return;
        }

        triggerGameAction('finish', {
            gameId: game.id,
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function validateGameAction(action, params) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Live.validateGameAction', true);
            gameAction(`validate/${action}`, params).then(result => {
                var matchNames;

                matchNames = (result && result.affectedGames) ? Object.values(result.affectedGames).map(game => {
                    return game.number;
                }) : [];

                if (matchNames.length <= 1) {
                    resolve();
                    return;
                }

                matchNames.sort(function(a, b) {
                    return a - b;
                });

                matchNames = matchNames.map(gameNumber => {
                    return __i18n('game/name', {number: gameNumber});
                });

                chmDialog.confirm(__i18n('dialog/confirm/affectedMatches/text', {matchNames: `<span class="text-no-wrap">${matchNames.join('</span><span class="color-white">,</span> <span class="text-no-wrap">')}</span>`}), {
                    title: __i18n('dialog/confirm/affectedMatches/title'),
                    buttonYes: __i18n('button/continue'),
                    buttonNo: __i18n('button/cancel')
                }).then(resolve).catch(reject);
            }).catch(error => {
                reject(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Live.validateGameAction', false);
            });
        });
    }

    function triggerGameAction(action, params) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Live.triggerGameAction', true);
            gameAction(action, params).then(result => {
                handleGameActionResult(result);

                resolve();
            }).catch(error => {
                reject(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Live.triggerGameAction', false);
            });
        });
    }

    function handleGameActionResult(result) {
        if (result.affectedTeams) {
            updateTeams(result.affectedTeams);
        }

        if (result.affectedGames) {
            update(result.affectedGames);
        }

        if (result.updateRanking) {
            updateRanking();
        }

        if (result.affectedRounds) {
            updateRounds(result.affectedRounds);
        }

        if (result.tables) {
            updateTables(result.tables);
        }

        if (result.rotationPreview) {
            ScoreTrekBattle.Tournament.GameEditor.rotationPreview(result.rotationPreview);
        }
    }

    function gameAction(action, params) {
        return new Promise(function(resolve, reject) {
            Api.request(`/battle/game/${action}`, params).then(result => {
                if (!result || !result.hasOwnProperty('affectedGames')) {
                    reject('PERSIST_FAILED');
                    return;
                }
                resolve(result);
            }).catch(reject);
        });
    }

    function getAffectedGroups(games) {
        var affectedGroups, gamesList;

        affectedGroups = {};

        gamesList = Array.isArray(games) ? games : Object.values(games);

        gamesList.forEach(game => {
            affectedGroups[game.groupId] = true;
        });

        return Object.keys(affectedGroups);
    }

    function getAffectedRounds(games) {
        var affectedRounds, gamesList;

        affectedRounds = {};

        gamesList = Array.isArray(games) ? games : Object.values(games);

        gamesList.forEach(game => {
            affectedRounds[game.roundId] = MAP.ROUNDS[game.roundId];
        });

        return affectedRounds;
    }

    function update(games) {
        updateAffectedGames(games);
        updateGroupRankings(getAffectedGroups(games));
        updateRounds(getAffectedRounds(games));
        updateMatchStatus();
        updateGroupsProgress();
        updateStatus();
    }

    function updateRunningGames(games) {
        Object.values(games).forEach(game => {
            ScoreTrekBattle.$body.find(`[data-ref-id="match_${game.id}"]`).attr({
                'data-game-target': game.gameTarget,
                'data-time-status': getTimeStatus(game)
            });
            ['duration'].forEach(gameKey => {
                MAP.GAMES[game.id][gameKey] = game[gameKey];
                ScoreTrekBattle.$body.find(`[data-ref-id="match_${gameKey}_${game.id}"]`).each(function() {
                    let content;
                    content = String(game[gameKey]);
                    if (this.textContent !== content) {
                        this.textContent = content;
                    }
                });
            });
        });
    }


    function updateTeams(teams) {
        teams.forEach(team => {
            MAP.TEAMS[team.id] = team;
            ScoreTrekBattle.Tournament.Match.updateTeam(team);
        });
    }

    function updateRounds(rounds) {
        let roundsList;

        roundsList = Array.isArray(rounds) ? rounds : Object.values(rounds);

        roundsList.forEach(round => {
            renderRoundData(round);
            updateRoundStatus(round);
        });
    }

    function updateAffectedGames(games) {
        let gamesList, gamesPromises;

        gamesPromises = [];

        gamesList = Array.isArray(games) ? games : Object.values(games);

        gamesList.forEach(game => {
            ScoreTrekBattle.$body.find(`[data-ref-id="match_${game.id}"]`).each(function() {
                MAP.GAMES[game.id] = game;
                gamesPromises.push(renderGameData(game, $(this), true));
            });
        });

        Promise.all(gamesPromises).catch(ignore => {}).finally(() => {
            updateMatchStatus();

            if (STATUS.gamesDialog) {
                STATUS.gamesDialog.$filters.find('[data-match-filter].isActive').trigger('click');
            }
        });
    }

    function updateRankings() {
        var groupIds;

        groupIds = [''].concat(Object.keys(MAP.GROUPS));
        updateGroupRankings(groupIds);
    }

    function updateGroupRankings(groupIds) {
        groupIds.forEach(groupId => {
            updateRanking(groupId);
        });
    }

    function updateTables(tables) {
        if (!tables) {
            return;
        }

        updateAvailableTables(parseInt(tables.available, 10) || 0);
        updateTotalTables(parseInt(tables.total, 10) || 0);
    }

    function updateAvailableTables(tableCount) {
        if (!STATUS.$view || !STATUS.tournament) {
            return;
        }

        STATUS.$view.find('[data-id="tablesAvailable"]').text(tableCount);

        if (!isEditable()) {
            return;
        }

        hasGamesReady = (STATUS.$view.find('[data-id="rounds"] [data-game-id][data-game-status="ready"]:not(.hasOccupiedTeams)').length > 0);

        STATUS.$view.find('[data-id="nextMatchIndicator"]').toggleClass('isFlashing', ((tableCount > 0) && hasGamesReady));
    }

    function updateTotalTables(tableCount) {
        if (!STATUS.$view || !STATUS.tournament) {
            return;
        }

        STATUS.$view.find('[data-id="tablesTotal"]').text(tableCount);
    }

    function loadRanking(tournamentId, groupId) {
        return new Promise(function(resolve, reject) {
            if (!tournamentId) {
                tournamentId = STATUS.tournament.id;
            }
            Api.request('/battle/tournament/ranking', {
                tournamentId: tournamentId,
                groupId: groupId
            }).then(result => {
                resolve(result);
            }).catch(error => {
                console.warn(error);
                reject(error);
            });
        });
    }

    function updateRanking(groupId) {
        loadRanking(null, groupId).then(result => {
            if (!result) {
                return;
            }
            renderRanking(result.ranking, result.group, groupId);
        }).catch(error => {
            console.warn(error);
            reject(error);
        });
    }

    function renderRanking(ranking, group, groupId) {
        if (!ranking) {
            return;
        }

        ScoreTrekBattle.Tournament.Ranking.render(STATUS.$view, STATUS.tournament, MAP.TEAMS, ranking, group ? group.qualificantsCount : STATUS.tournament.qualificantsCount).then($rankings => {
            var $group;

            if (groupId) {
                $group = STATUS.$view.find(`[data-group-id="${groupId}"]`);
                $group.find('[data-id="groupRankings"]').empty().append($rankings);
                $group.toggleClass('hasPendingConflict', group ? group.hasConflict : false);
                $group.toggleClass('hasSolvedConflict', group ? group.isConflictSolved : false);

                updateGroupMarkers(group);
            } else {
                STATUS.$view.find(`[data-id="tournamentRankingsWrapper"]`).addClass('hasParticipantControls').toggleClass('hasQualificants', (STATUS.tournament.qualificantsCount > 0))
                STATUS.$view.find(`[data-id="tournamentRankings"]`).empty().append($rankings);
            }
        });
    }

    function updateGroupMenuItems() {
        Object.values(MAP.GROUPS).forEach(group => {
            updateGroupMarkers(group);
        });
    }

    function updateGroupMarkers(group) {
        var $menuItemRankings, groupHasMarker, menuHasMarker;
        $menuItemRankings = MAP.MENU[`${STATUS.tournament.id}_${group.id}_rankings`];
        if ($menuItemRankings) {
            menuHasMarker = (group.hasConflict && !group.isConflictSolved);
            $menuItemRankings.attr('data-has-marker', menuHasMarker ? 'yes' : 'no');
            $menuItemRankings.closest('[data-menu-group-id]').toggleClass('hasMarker', menuHasMarker);
        }

        groupHasMarker = (STATUS.$view.find('[data-id="menu"] [data-has-marker="yes"]').length > 0);
        STATUS.$view.find('[data-id="menuToggle"]').toggleClass('hasMarker', groupHasMarker);
    }

    function getGameResult(gameId, currentGameResult, currentError) {
        ScoreTrekBattle.Tournament.GameEditor.result(gameId, currentGameResult, currentError).then(gameResult => {
            triggerGameAction('finish', {
                gameId: gameId,
                gameResult: gameResult
            }).catch(error => {
                getGameResult(gameId, gameResult, error);
            });
        }).catch(error => {
            if (!error) {
                return;
            }
            chmDialog.error(error);
        });
    }

    function getGamePdf(gameId) {
        ScoreTrekBattle.View.loading('Tournament.Live.getGamePdf', true);
        Api.request('/battle/game/history', {
            gameId: gameId
        }).then(result => {
            if (!result || !result.history) {
                chmDialog.error('error/GAME_HAS_NO_HISTORY');
                return;
            }

            ScoreTrekBattle.View.loading('Tournament.Live.getGamePdf.generateHistory', true);
            Pdf.generateHistory(result.history).then(pdf => {

                ScoreTrekBattle.View.loading('Tournament.Live.getGamePdf.storeGamePdf', true);
                FileManager.storeGamePdf(pdf.fileBase64, pdf.fileName).then(url => {
                    FileManager.openWindow(
                        url,
                        __i18n('pdf/generated/title'),
                        __i18n('pdf/generated/text'),
                        __i18n('button/download'),
                        '<i class="fas fa-download"></i>'
                    );
                }).catch(error => {
                    console.warn(error);
                    Pdf.showError();
                }).finally(() => {
                    ScoreTrekBattle.View.loading('Tournament.Live.getGamePdf.storeGamePdf', false);
                });

            }).catch(error => {
                console.error(error);
                Pdf.showError();
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Live.getGamePdf.generateHistory', false);
            });

        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Live.getGamePdf', false);
        });
    }

    function drawRound(roundId, isManual) {
        ScoreTrekBattle.View.loading('Tournament.Live.drawRound', true);

        Api.request('/battle/round/get', {roundId: roundId}).then(result => {
            var round, isDrawable;

            if (result && result.round) {
                MAP.ROUNDS[result.round.id] = result.round;
                updateRoundStatus(result.round);
            }

            round = MAP.ROUNDS[roundId];

            isDrawable = isDrawAvailable(round);

            if (!isDrawable) {
                chmDialog.info(__i18n('error/ROUND_DRAW_NOT_READY'));
                return;
            }

            isManual = round.isEditable || isManual;

            confirmDrawRound(round, isManual).then(() => {
                if (isManual) {
                    ScoreTrekBattle.Tournament.Draw.edit(STATUS.tournament, round, MAP.TEAMS).then(teams => {
                        drawRoundRequest(round, teams);
                    });
                } else {
                    drawRoundRequest(round);
                }
            }).catch(ignore => {});
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Live.drawRound', false);
        });
    }

    function confirmDrawRound(round, isManual) {
        return new Promise((resolve, reject) => {
            let drawType;

            if (round.isEditable || (round.isRandomDrawPending && isManual)) {
                resolve();
                return;
            }

            drawType = round.isRandomDrawPending ? 'randomDraw' : (isManual ? 'repeatManualDraw' : 'repeatRandomDraw');

            chmDialog.confirm(__i18n(`dialog/confirm/${drawType}/text`), {
                title: __i18n(`dialog/confirm/${drawType}/title`),
                buttonYes: __i18n(`dialog/confirm/${drawType}/confirm`),
                buttonNo: __i18n('button/cancel')
            }).then(resolve).catch(reject);

        });
    }

    function drawRoundRequest(round, teams) {
        ScoreTrekBattle.View.loading('Tournament.Live.drawRoundRequest', true);

        Api.request(round.isEditable ? '/battle/round/assign/manual' : (teams ? '/battle/round/draw/manual' : '/battle/round/draw/random'), {
            roundId: round.id,
            teams: round.isEditable ? teams : (teams ? teams.map(team => { return team.team2; }) : null)
        }).then(result => {
            handlePollResult({
                games: result.games,
                rounds: result.rounds
            });
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Live.drawRoundRequest', false);
            pollGames();
        });
    }

    function editGameTarget(gameId, gameData, currentError) {
        ScoreTrekBattle.Tournament.GameEditor.target(gameId, gameData, currentError).then(gameData => {
            gameData.gameId = gameId;
            triggerGameAction('target', gameData).catch(error => {
                editGameTarget(gameId, gameData, error);
            });
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function editRoundTarget(roundId, gameData, currentError) {
        ScoreTrekBattle.Tournament.GameEditor.roundTarget(roundId, gameData, currentError).then(gameData => {
            gameData.roundId = roundId;
            triggerGameAction('roundTarget', gameData).catch(error => {
                editRoundTarget(roundId, gameData, error);
            });
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function editGroupTarget(groupId, gameData, currentError) {
        ScoreTrekBattle.Tournament.GameEditor.groupTarget(groupId, gameData, currentError).then(gameData => {
            gameData.groupId = groupId;
            triggerGameAction('groupTarget', gameData).catch(error => {
                editGroupTarget(groupId, gameData, error);
            });
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function editGameTimeLimit(gameId, gameData, currentError) {
        ScoreTrekBattle.Tournament.GameEditor.timeLimit(gameId, gameData, currentError).then(gameData => {
            gameData.gameId = gameId;
            triggerGameAction('timeLimit', gameData).catch(error => {
                editGameTimeLimit(gameId, gameData, error);
            });
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function editRoundTimeLimit(roundId, gameData, currentError) {
        ScoreTrekBattle.Tournament.GameEditor.roundTimeLimit(roundId, gameData, currentError).then(gameData => {
            gameData.roundId = roundId;
            triggerGameAction('roundTimeLimit', gameData).catch(error => {
                editRoundTimeLimit(roundId, gameData, error);
            });
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function editGroupTimeLimit(groupId, gameData, currentError) {
        ScoreTrekBattle.Tournament.GameEditor.groupTimeLimit(groupId, gameData, currentError).then(gameData => {
            gameData.groupId = groupId;
            triggerGameAction('groupTimeLimit', gameData).catch(error => {
                editGroupTimeLimit(groupId, gameData, error);
            });
        }).catch(error => {
            chmDialog.error(error);
        });
    }

    function randomizeRound(roundId) {
        let $round, matchIds;

        $round = STATUS.$view.find(`[data-round-id="${roundId}"]`);

        if ($round.length === 0) {
            return;
        }

        matchIds = $round.find('[data-game-id][data-game-status="ready"]').get().map(match => {
            return match.dataset.gameId;
        });

        randomizeGames(matchIds);
    }

    function randomizeGroup(groupId) {
        let $group, matchIds;

        $group = STATUS.$view.find(`[data-group-id="${groupId}"]`);

        if ($group.length === 0) {
            return;
        }

        matchIds = $group.find('[data-game-id][data-game-status="ready"]').get().map(match => {
            return match.dataset.gameId;
        });

        randomizeGames(matchIds);
    }

    async function randomizeGames(matchIds) {
        let matchCount, matchTotal, title;

        matchTotal = matchIds.length;

        title = document.title;

        matchCount = 0;
        while(matchIds.length > 0) {
            matchId = matchIds.shift();
            matchCount++;
            document.title = `${matchCount} / ${matchTotal} | ${title}`;
            await randomizeGame(matchId);
        }

        document.title = title;
    }

    function getRandomGameResult(gameTarget) {
        let isTeam1, target;

        target = gameTarget || 1;
        isTeam1 = (Math.random() > 0.5);

        return {
            result1: isTeam1 ? target : Math.floor(Math.random() * target),
            result2: isTeam1 ? Math.floor(Math.random() * target) : target,
            takes1: 1,
            takes2: 1,
            maxBreak1: 1,
            maxBreak2: 1
        };
    }

    function randomizeGame(gameId) {
        return new Promise(resolve => {
            let game;

            game = MAP.GAMES[gameId];

            triggerGameAction('finish', {
                gameId: gameId,
                gameResult: getRandomGameResult(game ? game.gameTarget : 1)
            }).catch(ignore => {
            }).finally(() => {
                resolve();
            });
        });
    }

    function showGamesDialog(filter) {
        let games;

        if (!STATUS.tournament) {
            return;
        }

        if (STATUS.gamesDialog) {
            STATUS.gamesDialog.dialog.close();
            STATUS.gamesDialog = null;
            STATUS.gotoGameId = null;
        }

        games = getAllGames(true);

        renderGames(games).then(gameListItems => {
            STATUS.gamesDialog = buildGamesDialog(gameListItems, {
                filter: filter,
                hasControls: isEditable(),
                onShow: () => {
                    updateMatchStatus();
                },
                afterClose: () => {
                    if (STATUS.gotoGameId) {
                        gotoMatch(STATUS.gotoGameId);
                    }
                    STATUS.gamesDialog = null;
                }
            });
        });
    }

    function buildGamesDialog(gameListItems, options) {
        let $title, $filters, $matchItems, $matchItemsItems, $empty, filters;

        gameListItems.forEach($game => {
            $game.find('[data-id="matchName"],[data-id="matchStatus"]').removeAttr('data-trigger-action');
            $game.attr('data-trigger-action', 'match.goto');
        });

        $title = $('<div>').addClass('mb-medium').text(__i18n('tournament/title/matches'));

        $filters = $('<div>').addClass('match-filters');

        $empty = $('<div>').addClass('tournament-preset-list-item isEmpty').append(
            '<i class="fa-solid fa-inbox"></i>',
            $('<span>').addClass('mt-small text-center').html(__i18n('match/none'))
        );

        filters = {
            all: {
                icon: '',
                colorClass: 'color-white'
            },
            pending: {
                icon: '<i class="fa-regular fa-clock"></i>',
                colorClass: 'color-blue'
            },
            ready: {
                icon: '<i class="fa-solid fa-play"></i>',
                colorClass: 'color-yellow'
            },
            running: {
                icon: '<i class="fa-solid fa-hourglass-half"></i>',
                colorClass: 'color-light-pink'
            },
            done: {
                icon: '<i class="fa-solid fa-check"></i>',
                colorClass: 'color-green'
            }
        };

        Object.keys(filters).forEach(filterKey => {
            $filters.append(
                $('<span>')
                    .addClass(`match-filter${filters[filterKey].icon ? ' hasIcon' : ''}`)
                    .attr('data-match-filter', filterKey)
                    .append(
                        filters[filterKey].icon,
                        $('<span>').text(__i18n(`match/${filterKey}/filter`))
                    )
                    .on('click', function(event) {
                        let currentFilter, hasGames, visibleCount, firstVisibleCount;

                        event.stopPropagation();
                        event.preventDefault();

                        currentFilter = $filters.attr('data-active-filter');

                        $filters.attr('data-active-filter', filterKey);
                        $filters.find('.match-filter').removeClass('isActive').filter(`[data-match-filter="${filterKey}"]`).addClass('isActive');

                        hasGames = false;
                        firstVisibleCount = 2;
                        visibleCount = 0;

                        gameListItems.forEach($game => {
                            let slideFunc, isVisible;

                            isVisible = ((filterKey === 'all') || ($game.attr('data-game-status') === filterKey));

                            slideFunc = isVisible ? 'slideDown' : 'slideUp';

                            hasGames = hasGames || isVisible;

                            $game.stop()[slideFunc](currentFilter ? 300 : 0, function() {
                                $game.attr('style', isVisible ? '' : 'display: none;');
                            });

                            $game.find('[data-id="matchMenu"]').toggleClass('isDown', (firstVisibleCount > 0));

                            if (isVisible) {
                                visibleCount++;
                                firstVisibleCount--;
                            }
                        });

                        $title.empty().append(
                            __i18n(`match/${filterKey}/title`),
                            $('<span>').addClass(`ml-small ${filters[filterKey].colorClass}`).text(visibleCount)
                        );

                        $filters.closest('.dialog').scrollTop(0);
                        $empty[hasGames ? 'slideUp' : 'slideDown'](currentFilter ? 300 : 0);
                        $matchItemsItems.toggleClass('hasGames', hasGames);
                    })
            );
        });

        $matchItemsItems = $('<div>').addClass('match-items-items mb-huge');

        $matchItems = $('<div>').addClass('match-items live mb-huge pb-huge').append(
            $matchItemsItems.append(
                gameListItems
            ),
            $empty
        );

        $matchItems.toggleClass('hasControls', !!options.hasControls);

        return {
            $filters: $filters,
            dialog: chmDialog({
                title: $('<div>').append(
                    $title,
                    $filters
                ),
                isPersistant: true,
                large: true,
                forceHeight: true,
                alignTop: true,
                paddingTop: false,
                paddingBottom: false,
                allowActions: true,
                content: $matchItems,
                afterClose: () => {
                    ScoreTrekBattle.Event.callFunction(options.afterClose);
                },
                onShow: () => {
                    let $filter;

                    ScoreTrekBattle.Event.callFunction(options.onShow);

                    $filter = $filters.find(`[data-match-filter="${options.filter}"]`);

                    if ($filter.length === 0) {
                        $filter = $filters.find(`[data-match-filter="all"]`);
                    }

                    $filter.trigger('click');
                }
            })
        };
    }

    function gotoMatch(gameId) {
        var $match;

        STATUS.gotoGameId = null;

        if (!STATUS.$view || !MAP.GAMES[gameId]) {
            return;
        }

        $match = STATUS.$view.find(`[data-game-id="${gameId}"]`);      
        
        forceToggleOpen($match);
        AnimationHandler.scrollIntoView($match).then(() => {
            AnimationHandler.pulse($match);
        });
    }

    function isDrawAvailable(round) {
        if (!round || !round.games) {
            return false;
        }

        return round.games.every(roundGame => {
            return isGameAssignable(MAP.GAMES[roundGame.id] || roundGame);
        });
    }

    function isGameAssignable(game) {
        if (!game.team1 || !(game.team2 || game.team2Designated)) {
            return false;
        }

        return (game.status === 'ready') || isByeResultRevertible(game);
    }

    function isLuckyLoserAvailable(roundId) {
        return Object.values(MAP.GAMES).filter(game => {
            return (game.roundId === roundId);
        }).every(game => {
            return ['pending', 'ready'].includes(game.status) || isByeResultRevertible(game);
        });
    }

    function getLuckyLoserCandidates() {
        let openGames;

        openGames = Object.values(MAP.GAMES).filter(game => {
            return (game.status !== 'done');
        });

        return Object.values(MAP.TEAMS).filter(team => {
            return (team.rank > 0) && !team.isSurrendered && !team.isDisqualified && !openGames.some(game => {
                return (game.team1 === team.id) || (game.team2 === team.id);
            });
        }).sort((team1, team2) => {
            return (team1.rank - team2.rank) || String(team1.name).localeCompare(String(team2.name));
        });
    }

    function isByeResultRevertible(game) {
        if ((game.status !== 'done') || !hasBye(game)) {
            return false;
        }

        return ['winnerTo', 'loserTo'].every(gameKey => {
            let toGame;

            toGame = MAP.GAMES[String(game[gameKey] || '').split(':')[0]];

            if (!toGame) {
                return true;
            }

            return (toGame.status !== 'running') && ((toGame.status !== 'done') || hasBye(toGame));
        });
    }

    function hasBye(game) {
        if (!game) {
            return false;
        }
        return (game.team1 === '__BYE__') || (game.team2 === '__BYE__');
    }

    function confirmRandomize(translationKey, event, referenceName) {
        return new Promise((resolve, reject) => {
            if (event.ctrlKey) {
                resolve();
                return;
            }

            chmDialog.confirm(__i18n(`dialog/confirm/${translationKey}/text`, {referenceName: referenceName}, true), {
                title: __i18n(`dialog/confirm/${translationKey}/title`),
                buttonYes: __i18n('button/yes'),
                buttonNo: __i18n('button/no')
            }).then(() => {
                resolve();
            }).catch(reject);
        });
    }

    function confirmTeamAction(action, teamId) {
        return new Promise(function(resolve, reject) {
            let promptData;

            promptData = null;

            if (action === 'handicap') {
                promptData = {
                    value: String(getTeamHandicap(teamId)),
                    type: 'number'
                };
            }

            if (action === 'rename') {
                promptData = {
                    value: getTeamName(teamId),
                    type: 'text'
                };
            }

            if (promptData !== null) {
                chmDialog.prompt(
                    {
                        title: __i18n(`dialog/confirm/team/${action}/title`),
                        prompt: __i18n(
                            `dialog/confirm/team/${action}/text`,
                            {
                                teamName: getTeamName(teamId)
                            },
                            true
                        ),
                        value: promptData.value,
                        type: promptData.type
                    }
                ).then(newValue => {
                    if (newValue === null) {
                        return reject();
                    }
                    resolve(newValue);
                }).catch(reject);

                return;
            }

            if (!['surrender', 'disqualify'].includes(action)) {
                console.warn('Invalid team action:', action);
                reject();
                return;
            }

            if (!teamId) {
                console.warn('Missing team ID for team action:', action);
                reject();
                return;
            }

            if (!STATUS.tournament) {
                reject();
                return;
            }

            chmDialog.confirm(
                __i18n(
                    `dialog/confirm/team/${action}/text`,
                    {
                        teamName: getTeamName(teamId)
                    },
                    true
                ),
                {
                    title: __i18n(`dialog/confirm/team/${action}/title`),
                    buttonYes: __i18n(`button/confirm`),
                    buttonNo: __i18n('button/cancel')
                }
            ).then(() => {
                resolve();
            }).catch(reject);
        });
    }

    function triggerTeamAction(action, teamId, actionData) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Live.triggerTeamAction', true);
            teamAction(action, $.extend(
                {
                    tournamentId: STATUS.tournament.id,
                    teamId: teamId
                },
                actionData
            )).then(result => {
                handleGameActionResult(result);

                resolve();
            }).catch(error => {
                reject(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Live.triggerTeamAction', false);
            });
        });
    }

    function teamAction(action, params) {
        return new Promise(function(resolve, reject) {
            Api.request(`/battle/team/${action}`, params).then(result => {
                if (!result || !result.hasOwnProperty('affectedTeams')) {
                    reject('error/PERSIST_FAILED');
                    return;
                }
                resolve(result);
            }).catch(reject);
        });
    }

    function checkHasDifferentTournament(tableId) {
        if (!tableId) {
            return;
        }

        ScoreTrekBattle.View.loading('Tournament.Live.tableStatus', true);

        Api.request('/battle/table/status', {
            tableId: tableId
        }).then(result => {
            if (!STATUS.tournament) {
                return;
            }

            if (!result || !result.table || !result.table.currentTournamentId) {
                return;
            }

            if (result.table.currentTournamentId === STATUS.tournament.id) {
                return;
            }

            chmDialog.info(__i18n(`table/usage/dialog/foreign`, {
                tableName: result.table.name,
                tournamentId: result.table.currentTournamentId
            }));
            
        }).catch(error => {
            chmDialog.info(__i18n(`table/usage/dialog/unknown`));

        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Live.tableStatus', false);
        });

    }

    _this = {
        getOpenState: function(toggleId) {
            return getOpenState(toggleId);
        },
        storeOpenState: function(toggleId, isOpen) {
            return storeOpenState(toggleId, isOpen);
        },
        forceToggleOpen: function($child, isOpen) {
            return forceToggleOpen($child, isOpen);
        },
        showMatchesDialog: function(gameListItems, options) {
            return buildGamesDialog(gameListItems, options);
        },
        getRandomGameResult: function(gameTarget) {
            return getRandomGameResult(gameTarget);
        },
        confirmRandomize: function(translationKey, event, referenceName) {
            return confirmRandomize(translationKey, event, referenceName);
        },
        getGame: function(gameId) {
            return MAP.GAMES[gameId] || null;
        },
        getGroup: function(groupId) {
            return MAP.GROUPS[groupId] || null;
        },
        getGameName: function(game) {
            return getGameName(game);
        },
        applyGameStats: function($game, game) {
            applyGameStats($game, game);
        },
        applyBreakMode: function($info, gameType, isAlternatingBreak) {
            applyBreakMode($info, gameType, isAlternatingBreak);
        },
        getRoundName: function(round) {
            return getRoundName(round);
        },
        getGroupName: function(group) {
            return getGroupName(group);
        },
        renderGameData: function(game, $game, highlightUpdates) {
            return renderGameData(game, $game, highlightUpdates);
        },
    };

    ScoreTrekBattle.View.register('/tournament/live', onViewRender, onViewLoad, onViewUpdate, onViewUnload);
    ScoreTrekBattle.View.register('/tournament/results', onViewRender, onViewLoad, onViewUpdate, onViewUnload);

    ScoreTrekBattle.Event.on('action.match.next', function() {
        var $pendingConflicts, $pendingConflict, $nextGames, $nextGame, $finalization, nextGameNumber;

        if (!STATUS.$view) {
            return;
        }

        if ((STATUS.tournament.status === 'done') && !STATUS.tournament.isFinalized) {
            $finalization = STATUS.$view.find(`[data-anchor="${STATUS.tournament.id}_finalization"]`);
            if ($finalization.is(':visible')) {
                AnimationHandler.scrollIntoView($finalization).then(() => {
                    AnimationHandler.pulse($finalization);
                });
                return;
            }
        }

        $pendingConflicts = STATUS.$view.find('[data-group-id].hasPendingConflict:not(.hasSolvedConflict) [data-id="groupWarning"]');

        if ($pendingConflicts.length > 0) {
            $pendingConflict = $pendingConflicts.first();
            forceToggleOpen($pendingConflict);
            AnimationHandler.scrollIntoView($pendingConflict).then(() => {
                AnimationHandler.pulse($pendingConflict);
            });

            return;
        }

        showGamesDialog('ready');
    });

    ScoreTrekBattle.Event.on('action.table.match.focus', function(event, tableId, closeDialog) {
        var $game;

        if (!STATUS.$view || !tableId) {
            return;
        }

        if (closeDialog) {
            chmDialog.close();
        }

        $game = STATUS.$view.find(`[data-game-table-id="${tableId}"]`);

        if ($game.length === 0) {
            checkHasDifferentTournament(tableId);
            return;
        }

        setTimeout(() => {
            forceToggleOpen($game);
            AnimationHandler.scrollIntoView($game).then(() => {
                AnimationHandler.pulse($game);
            });
        }, closeDialog ? 500 : 0);
    });

    ScoreTrekBattle.Event.on('action.tables.usage', function() {
        if (!STATUS.tournament) {
            return;
        }
        ScoreTrekBattle.Tournament.Table.usage(STATUS.tournament).then(table => {
            let $game;

            if (!table || table.isAvailable) {
                chmDialog.info(__i18n('table/usage/dialog/unused'));
                return;
            }

            if (table.currentTournamentId !== STATUS.tournament.id) {
                checkHasDifferentTournament(table.id);
                return;
            }

            $game = STATUS.$view.find(`[data-game-id="${table.currentGameId}"]`);

            forceToggleOpen($game);
            AnimationHandler.scrollIntoView($game).then(() => {
                AnimationHandler.pulse($game);
            });
        }).catch(error => {
            if (!error) {
                return;
            }
            chmDialog.error(error);
        });

    });

    // Die Match-Aktionen tragen dieselben Namen wie im Liga-Spieltag, weil sie
    // dasselbe HTML nutzen. Ein Match, das diese Ansicht nicht kennt, gehoert
    // einer anderen — dann still aussteigen, statt es anzufassen.
    function getOwnGameId(element) {
        let gameId;

        gameId = $(element).closest('[data-game-id]').attr('data-game-id');

        return (gameId && MAP.GAMES[gameId]) ? gameId : '';
    }

    ScoreTrekBattle.Event.on('action.match.start', function() {
        var gameId, game;

        gameId = getOwnGameId(this);

        game = MAP.GAMES[gameId] || null;

        if (!game) {
            return;
        }

        if (hasBye(game)) {
            finishGameWithBye(game);
            return;
        }

        ScoreTrekBattle.Tournament.Table.select(game).then(table => {
            triggerGameAction('start', {
                gameId: game.id,
                tableId: table.id
            }).catch(error => {
                if (error.message === 'TABLE_HAS_GAME') {
                    chmDialog.info(__i18n(`table/hasGame`, {
                        tableName: table.name,
                        tableId: table.id
                    }));
                } else {
                    chmDialog.error(error);
                }
            });
        }).catch(error => {
            if (!error) {
                return;
            }
            chmDialog.error(error, {tableType: __i18n(`table/type/option/${error.errorData ? (error.errorData.tableType || '') : ''}`)});
        });

    });

    ScoreTrekBattle.Event.on('action.match.cancel', function() {
        var $game;

        if (getOwnGameId(this) === '') {
            return;
        }

        $game = $(this).closest('[data-game-id]');

        chmDialog.confirm(__i18n('dialog/confirm/cancelMatch/text', {matchName: $game.find('[data-id="matchName"]').text()}, true), {
            title: __i18n('dialog/confirm/cancelMatch/title'),
            buttonYes: __i18n('button/cancelMatch'),
            buttonNo: __i18n('button/no')
        }).then(() => {
            triggerGameAction('cancel', {
                gameId: $game.attr('data-game-id')
            }).catch(error => {
                chmDialog.error(error);
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.match.finish', function() {
        var gameId, $game;

        gameId = getOwnGameId(this);

        if (gameId === '') {
            return;
        }

        $game = $(this).closest('[data-game-id]');

        getGameResult(gameId);
    });
    
    ScoreTrekBattle.Event.on('action.match.tie', function() {
        var gameId, $game;

        gameId = getOwnGameId(this);

        if (gameId === '') {
            return;
        }

        $game = $(this).closest('[data-game-id]');

        ScoreTrekBattle.Tournament.GameEditor.tieResult(gameId).then(gameResult => {
            triggerGameAction('finish', {
                gameId: gameId,
                gameResult: gameResult
            }).catch(error => {
                chmDialog.error(error);
            });
        });
    });
    
    ScoreTrekBattle.Event.on('action.match.pdf', function() {
        var gameId, $game;

        gameId = getOwnGameId(this);

        if (gameId === '') {
            return;
        }

        $game = $(this).closest('[data-game-id]');

        getGamePdf(gameId);
    });
    
    ScoreTrekBattle.Event.on('action.match.editResult', function() {
        // TODO implement result editing
        chmDialog.error(new Error('TOURNAMENT_GAME_RESULT_NOT_EDITABLE'));
    });

    ScoreTrekBattle.Event.on('action.match.editRoundTarget', function() {
        var roundId, $round;

        $round = $(this).closest('[data-round-id]');
        roundId = $round.attr('data-round-id');

        editRoundTarget(roundId);
    });

    ScoreTrekBattle.Event.on('action.match.editGroupTarget', function() {
        var groupId, $group;

        $group = $(this).closest('[data-group-id]');
        groupId = $group.attr('data-group-id');

        editGroupTarget(groupId);
    });

    ScoreTrekBattle.Event.on('action.match.editTarget', function() {
        var gameId, $game;

        gameId = getOwnGameId(this);

        if (gameId === '') {
            return;
        }

        $game = $(this).closest('[data-game-id]');

        editGameTarget(gameId);
    });

    ScoreTrekBattle.Event.on('action.match.editRoundTimeLimit', function() {
        var roundId, $round;

        $round = $(this).closest('[data-round-id]');
        roundId = $round.attr('data-round-id');

        editRoundTimeLimit(roundId);
    });

    ScoreTrekBattle.Event.on('action.match.editGroupTimeLimit', function() {
        var groupId, $group;

        $group = $(this).closest('[data-group-id]');
        groupId = $group.attr('data-group-id');

        editGroupTimeLimit(groupId);
    });

    ScoreTrekBattle.Event.on('action.match.editTimeLimit', function() {
        var gameId, $game;

        gameId = getOwnGameId(this);

        if (gameId === '') {
            return;
        }

        $game = $(this).closest('[data-game-id]');

        editGameTimeLimit(gameId);
    });

    ScoreTrekBattle.Event.on('action.match.randomize', function(event) {
        let $game, gameId;

        if (!STATUS.tournament || !STATUS.$view) {
            return;
        }

        $game = $(this).closest('[data-game-id]');
        gameId = $game.attr('data-game-id');

        confirmRandomize('randomizeMatch', event, $game.find('[data-id="matchName"]').text()).then(() => {
            randomizeGame(gameId);
        }).catch(ignore => {});

    });

    ScoreTrekBattle.Event.on('action.match.randomizeGroup', function(event) {
        let $group;

        $group = $(this).closest('[data-group-id]');
        groupId = $group.attr('data-group-id');

        confirmRandomize('randomizeGroup', event, $group.attr('data-group-name')).then(() => {
            randomizeGroup(groupId);
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.match.randomizeRound', function(event) {
        let $round;

        $round = $(this).closest('[data-round-id]');
        roundId = $round.attr('data-round-id');

        confirmRandomize('randomizeGroup', event, $round.find('[data-id="roundTitle"]').text()).then(() => {
            randomizeRound(roundId);
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.match.luckyLoser', function() {
        let game, candidates;

        game = MAP.GAMES[getOwnGameId(this)] || null;

        if (!game) {
            return;
        }

        if (!isLuckyLoserAvailable(game.roundId)) {
            chmDialog.info(__i18n('error/TOURNAMENT_GAME_LUCKY_LOSER_NOT_AVAILABLE'));
            return;
        }

        candidates = getLuckyLoserCandidates();

        if (candidates.length === 0) {
            chmDialog.info(__i18n('tournament/luckyLoser/none'));
            return;
        }

        ScoreTrekBattle.Tournament.Group.renderTeams(candidates, STATUS.tournament.preset.teamSize || 1).then($teams => {
            chmSelect({
                title: __i18n('tournament/luckyLoser/select', {matchName: getGameName(game.number)}, true),
                items: candidates.map((team, index) => {
                    return {
                        value: team.id,
                        html: $teams[index]
                    };
                }),
                isSearchable: true,
                onSelect: function(teamId) {
                    triggerGameAction('luckyLoser', {
                        gameId: game.id,
                        teamId: teamId
                    }).catch(error => {
                        chmDialog.error(error);
                    }).finally(() => {
                        startPolling();
                    });
                }
            });
        });
    });

    ScoreTrekBattle.Event.on('action.match.reset', function() {
        var $game, gameId;

        gameId = getOwnGameId(this);

        if (gameId === '') {
            return;
        }

        $game = $(this).closest('[data-game-id]');

        chmDialog.confirm(__i18n('dialog/confirm/resetMatch/text', {matchName: $game.find('[data-id="matchName"]').text()}, true), {
            title: __i18n('dialog/confirm/resetMatch/title'),
            buttonYes: __i18n('button/reset'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            validateGameAction('reset', {
                gameId: gameId
            }).then(() => {
                triggerGameAction('reset', {
                    gameId: gameId
                }).catch(error => {
                    chmDialog.error(error);
                }).finally(() => {
                    startPolling();
                });
            }).catch(error => {
                chmDialog.error(error);
            });
        }).catch(ignore => {});
    });
    
    ScoreTrekBattle.Event.on('action.live.menu.close', function() {
        if (STATUS.$view) {
            ScoreTrekBattle.$body.removeClass('sideMenu-open');
        }
    });

    ScoreTrekBattle.Event.on('action.tournament.treeView', function() {
        if (!STATUS.tournament || !STATUS.tournament.preset || !STATUS.tournament.preset.hasTreeView) {
            return;
        }

        ScoreTrekBattle.Tournament.TreeView.render(STATUS, MAP);
    });    

    ScoreTrekBattle.Event.on('action.tournament.finalize', function() {
        let $conflicts, $conflictWarning;

        $conflicts = STATUS.$view.find('[data-group-id].hasPendingConflict:not(.hasSolvedConflict)');

        if ($conflicts.length > 0) {
            forceToggleOpen($conflicts.first().find('[data-id="groupRankingsWrapper"]'));
            $conflictWarning = $conflicts.first().find('[data-id="groupWarning"]');
            AnimationHandler.scrollIntoView($conflictWarning, $conflictWarning.height() > (0.8 * window.innerHeight)).then(() => {
                AnimationHandler.pulse($conflictWarning);
            });
            return;
        }

        doTournamentAction('finalize', {validate: true}).then(result => {
            let confirmationVars;

            confirmationVars = {
                pointsMapName: result.validation.pointsMap ? result.validation.pointsMap.name : __i18n('form/options/pointsMap/default')
            };

            if (!result.validation || !result.validation.valid) {
                chmDialog.error(__i18n('error/TOURNAMENT_FINALIZATION_FAILED'));
                return;
            }

            if (result.validation.confirmation) {
                confirmFinalization(result.validation.confirmation, confirmationVars).then(isFinalized => {
                    if (isFinalized) {
                        return;
                    }

                    triggerTournamentAction('finalize', {}, confirmationVars);
                }).catch(error => {
                    if (error === null) {
                        return;
                    }
                    console.error(error);
                    chmDialog.error(__i18n('error/TOURNAMENT_FINALIZATION_FAILED'));
                });
                return;
            }

            triggerTournamentAction('finalize', {}, confirmationVars);
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.tournament.unseal', function() {
        triggerTournamentAction('unseal');
    });
    
    ScoreTrekBattle.Event.on('action.match.info', function() {
        var gameId;
        gameId = $(this).closest('[data-game-id]').attr('data-game-id');
        if (MAP.GAMES[gameId]) {
            showMatchInfo(MAP.GAMES[gameId]);
            return false;
        }
    });

    ScoreTrekBattle.Event.on('action.match.goto', function() {
        var gameId;

        ScoreTrekBattle.Event.trigger('action.live.menu.close');

        gameId = $(this).attr('data-game-id');

        if (STATUS.gamesDialog) {
            STATUS.gotoGameId = gameId;
            STATUS.gamesDialog.dialog.close();
            return;
        }

        gotoMatch(gameId);
    });

    ScoreTrekBattle.Event.on('action.matches.running', function() {
        showGamesDialog('running');
    });

    ScoreTrekBattle.Event.on('action.matches.done', function() {
        showGamesDialog('done');
    });

    ScoreTrekBattle.Event.on('action.matches.all', function() {
        showGamesDialog();
    });

    ScoreTrekBattle.Event.on('action.item.toggle', function() {
        let $item, isOpen;

        $item = $(this).closest('[data-toggle-id]');

        isOpen = ($item.attr('data-is-open') === 'no');

        $item.attr('data-is-open', isOpen ? 'yes' : 'no');

        $item.find('[data-ref="toggle"]').first().stop()[isOpen ? 'slideDown' : 'slideUp'](200);

        storeOpenState($item.attr('data-toggle-id'), isOpen);
    });

    ScoreTrekBattle.Event.on('action.round.draw.random', function() {
        var roundId;

        roundId = $(this).closest('[data-round-id]').attr('data-round-id');

        drawRound(roundId, false);
    });

    ScoreTrekBattle.Event.on('action.round.draw.manual', function() {
        var roundId;

        roundId = $(this).closest('[data-round-id]').attr('data-round-id');

        drawRound(roundId, true);
    });

    ScoreTrekBattle.Event.on('action.team.setHandicap', function() {
        let teamId;

        teamId = $(this).closest('[data-team-id]').attr('data-team-id');

        confirmTeamAction('handicap', teamId).then(handicap => {
            triggerTeamAction('handicap', teamId, {handicap: handicap}).catch(error => {
                chmDialog.error(error);
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.team.editName', function() {
        let teamId;

        teamId = $(this).closest('[data-team-id]').attr('data-team-id');

        confirmTeamAction('rename', teamId).then(teamName => {
            triggerTeamAction('rename', teamId, {teamName: teamName}).catch(error => {
                chmDialog.error(error);
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.team.surrender', function() {
        let teamId;

        teamId = $(this).closest('[data-team-id]').attr('data-team-id');

        confirmTeamAction('surrender', teamId).then(() => {
            triggerTeamAction('surrender', teamId).catch(error => {
                chmDialog.error(error);
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.team.disqualify', function() {
        let teamId;

        teamId = $(this).closest('[data-team-id]').attr('data-team-id');

        confirmTeamAction('disqualify', teamId).then(() => {
            triggerTeamAction('disqualify', teamId).catch(error => {
                chmDialog.error(error);
            });
        }).catch(ignore => {});
    });

    ScoreTrekBattle.Event.on('action.group.conflict.solve', function() {
        var groupId;

        if (!STATUS.tournament) {
            return;
        }

        groupId = $(this).closest('[data-group-id]').attr('data-group-id');

        if (!MAP.GROUPS[groupId]) {
            return;
        }

        ScoreTrekBattle.Tournament.Ranking.editGroupQualificants(STATUS.tournament, groupId).then(affectedGames => {
            update(affectedGames);
            updateGroupRankings([groupId]);
        }).catch(error => {
            if (error) {
                chmDialog.error(error);
            }
        });
    });

    ScoreTrekBattle.Event.on('action.group.conflict.reset', function() {
        var groupId;

        if (!STATUS.tournament) {
            return;
        }

        groupId = $(this).closest('[data-group-id]').attr('data-group-id');

        if (!MAP.GROUPS[groupId]) {
            return;
        }

        ScoreTrekBattle.Tournament.Ranking.resetGroupQualificants(STATUS.tournament, groupId).then(affectedGames => {
            update(affectedGames);
            updateGroupRankings([groupId]);
            startPolling();
        }).catch(error => {
            if (error) {
                chmDialog.error(error);
            }
        });
    });

    $(window).on('resize', function() {
        if (STATUS.active) {
            startObserver();
        }
    });

    ScoreTrekBattle.Event.on('window.scrolled', function(event, scrollTop) {
        if (!STATUS.active) {
            return;
        }

        storeScrollTop(scrollTop);
    });

    ScoreTrekBattle.Event.on('adminMode.toggle', function(isAdminMode) {
        toggleHasControls();
    });

    return _this;
})();